"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4337],{

/***/ 1278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q2": function() { return /* binding */ createColorModeProvider; },
/* harmony export */   "jK": function() { return /* binding */ useViewportWidth; },
/* harmony export */   "uy": function() { return /* binding */ createColorStyles; },
/* harmony export */   "vs": function() { return /* binding */ transform; }
/* harmony export */ });
/* unused harmony exports ColorModeContext, createBox, getColorModeInitScriptElement, getColorModeInitScriptTag, propGetters, useColorMode, useColorModeState, useColorModeTheme, useThemeBreakpoint, useThemeBreakpoints, useThemeDown, useThemeUp */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _xstyled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7248);
/* harmony import */ var _xstyled_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4583);




/* eslint-disable no-undef */
function useThemeBreakpoints(theme) {
  return getBreakpoints({
    theme: theme
  });
}
/**
 * Minimum breakpoint width.
 * Null for the smallest breakpoint.
 */

function useThemeMinValue(theme, key) {
  var breakpoints = useThemeBreakpoints(theme);
  var value = breakpoints[key];
  return value === 0 ? null : value;
}
/**
 * Maximum breakpoint width. Null for the largest (last) breakpoint.
 * The maximum value is calculated as the minimum of the next one less 0.02px
 * to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.
 * See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
 * Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
 * See https://bugs.webkit.org/show_bug.cgi?id=178261
 */


function useThemeMaxValue(theme, key) {
  var breakpoints = useThemeBreakpoints(theme);
  var breakPoint = breakpoints[key];
  return breakPoint === 0 ? null : breakPoint - 0.02;
}

function useViewportWidth() {
  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(typeof window === 'undefined' ? null : window.innerWidth),
      width = _React$useState[0],
      setWidth = _React$useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleResize() {
      setWidth(window.innerWidth);
    } // Add the listener, then setWidth to avoid race.


    window.addEventListener('resize', handleResize);
    setWidth(window.innerWidth);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return width;
}
function useThemeBreakpoint(theme) {
  var breakpoints = useThemeBreakpoints(theme);
  var width = useViewportWidth();
  return useMemo(function () {
    return Object.keys(breakpoints).reverse().find(function (breakpoint) {
      return width !== null && width > breakpoints[breakpoint];
    }) || null;
  }, [breakpoints, width]);
}
function useThemeUp(theme, key) {
  var value = useThemeMinValue(theme, key);
  var width = useViewportWidth();
  return width !== null && value !== null && width >= value;
}
function useThemeDown(theme, key) {
  var value = useThemeMaxValue(theme, key);
  var width = useViewportWidth();
  return width !== null && value !== null && width < value;
}

function createBox() {
  return ["&&{", _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .system */ .ByQ, "}"];
}
createBox.meta = _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .system.meta */ .ByQ.meta;

var getNumber = function getNumber(transform) {
  return function (value) {
    var num = Number(value);
    return transform(Number.isNaN(num) ? value : num);
  };
};

var SPACES = /\s+/;

var getMultiDimensions = function getMultiDimensions(transform) {
  return function (value) {
    var values = value.split(SPACES);
    return function (p) {
      return values.map(function (value) {
        return transform(value)(p);
      }).join(' ');
    };
  };
};

var COMMA = /\s*,\s*/;

var getMultiValues = function getMultiValues(transform) {
  return function (value) {
    var values = value.split(COMMA);
    return function (p) {
      return values.map(function (value) {
        return transform(value)(p);
      }).join(',');
    };
  };
};

var getNumberInset = /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getInset */ .M5s);
var getNumberSpace = /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getSpace */ .Pjv);
var getMultiNumberSpace = /*#__PURE__*/getMultiDimensions(getNumberSpace);
var getNumberBorder = /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBorder */ .ubX);
var getNumberBorderWidth = /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBorderWidth */ .aqw);
var getMultiNumberBorderWidth = /*#__PURE__*/getMultiDimensions(getNumberBorderWidth);
var getNumberSize = /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getSize */ .apW);
var getMultiBorderStyle = /*#__PURE__*/getMultiDimensions(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBorderStyle */ .dR$);
var propGetters = {
  // getSpace
  margin: getMultiNumberSpace,
  'margin-top': getNumberSpace,
  'margin-bottom': getNumberSpace,
  'margin-left': getNumberSpace,
  'margin-right': getNumberSpace,
  padding: getMultiNumberSpace,
  'padding-top': getNumberSpace,
  'padding-bottom': getNumberSpace,
  'padding-left': getNumberSpace,
  'padding-right': getNumberSpace,
  gap: getMultiNumberSpace,
  'grid-gap': getMultiNumberSpace,
  'row-gap': getNumberSpace,
  'grid-row-gap': getNumberSpace,
  'column-gap': getNumberSpace,
  'grid-column-gap': getNumberSpace,
  // getColor
  color: _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  'background-color': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  'border-color': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  'border-top-color': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  'border-right-color': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  'border-bottom-color': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  'border-left-color': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  'outline-color': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  fill: _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  stroke: _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getColor */ .Lq4,
  // getRadius
  'border-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getRadius */ .H5b)),
  'border-top-left-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getRadius */ .H5b)),
  'border-top-right-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getRadius */ .H5b)),
  'border-bottom-right-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getRadius */ .H5b)),
  'border-bottom-left-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getRadius */ .H5b)),
  // getBorder
  border: getNumberBorder,
  'border-top': getNumberBorder,
  'border-right': getNumberBorder,
  'border-bottom': getNumberBorder,
  'border-left': getNumberBorder,
  // getBorderWidth
  'border-width': getMultiNumberBorderWidth,
  'border-top-width': getNumberBorderWidth,
  'border-right-width': getNumberBorderWidth,
  'border-bottom-width': getNumberBorderWidth,
  'border-left-width': getNumberBorderWidth,
  'outline-width': getNumberBorderWidth,
  // getBorderStyle
  'border-style': getMultiBorderStyle,
  'border-top-style': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBorderStyle */ .dR$,
  'border-right-style': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBorderStyle */ .dR$,
  'border-bottom-style': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBorderStyle */ .dR$,
  'border-left-style': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBorderStyle */ .dR$,
  'outline-style': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBorderStyle */ .dR$,
  // getShadow
  'box-shadow': /*#__PURE__*/getMultiValues(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getShadow */ .Xj4),
  'text-shadow': /*#__PURE__*/getMultiValues(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getShadow */ .Xj4),
  // getSize
  width: getNumberSize,
  height: getNumberSize,
  'max-width': getNumberSize,
  'max-height': getNumberSize,
  'min-width': getNumberSize,
  'min-height': getNumberSize,
  'mask-size': /*#__PURE__*/getMultiValues(getNumberSize),
  // getZIndex
  'z-index': /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getZIndex */ .KKi),
  // getFont
  'font-family': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getFont */ .qTy,
  // getFontSize
  'font-size': /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getFontSize */ .yvh),
  // getLineHeight
  'line-height': /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getLineHeight */ .Dpt),
  // getFontWeight
  'font-weight': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getFontWeight */ .Onc,
  // getLetterSpacing
  'letter-spacing': /*#__PURE__*/getNumber(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getLetterSpacing */ .cgZ),
  // getTransition
  transition: _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getTransition */ .ush,
  // getDuration
  'transition-duration': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getDuration */ .g9Y,
  'animation-duration': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getDuration */ .g9Y,
  // getAnimation
  animation: _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getAnimation */ .O8,
  // getInset
  top: getNumberInset,
  right: getNumberInset,
  bottom: getNumberInset,
  left: getNumberInset,
  // getTimingFunction
  'animation-timing-function': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getTimingFunction */ ._Dl,
  'transition-timing-function': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getTimingFunction */ ._Dl,
  // getTransform
  transform: _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getTransform */ .CkN,
  // getTransitionProperty
  'transition-property': _xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getTransitionProperty */ .fkS
};

var getMediaWidth = function getMediaWidth(getBreakpointBound) {
  return function (value) {
    return function (props) {
      var v = getBreakpointBound((0,_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBreakpoints */ .ler)(props), value); // getters return null for smallest, undefined for not found, and otherwise
      // a px string. Since we MUST emit a matcher at this point, use 0px for the
      // smallest case (always true for min, never true for max).

      return v === null ? '0' : v || value;
    };
  };
};

var mediaGetters = {
  'min-width': /*#__PURE__*/getMediaWidth(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBreakpointMin */ .oSz),
  'max-width': /*#__PURE__*/getMediaWidth(_xstyled_system__WEBPACK_IMPORTED_MODULE_1__/* .getBreakpointMax */ .EL6)
};

/* eslint-disable no-continue, no-loop-func, no-cond-assign */

var PROP_CHAR = "[-\\w]"; // prop value consists of non-semis and no curly braces unless backslash-escaped.
// This uses [\s\S] instead of . because IE11 doesn't support the s flag.

var VALUE_CHAR = "(?:\\\\[\\s\\S]|[^\\\\;{}])"; // prettier-ignore

var PROP_PATT = "(" + PROP_CHAR + "+)" + // capture prop name
"(\\s*:\\s*)" + // colon & whitespace
"(?=\\S)" + ( // prop value starts with non-whitespace
"(" + VALUE_CHAR + "*?)") + // capture prop value (non-greedy)
"(\\s*!important)?" + // capture !important
"(\\s*;)" // semi & whitespace
; // simplistic but workable media query value.

var MEDIA_CHAR = "[^{]"; // prettier-ignore

var MEDIA_PATT = "(@media\\b\\s*)" + // start of media query
"(?=\\S)" + ( // value starts with non-whitespace
"(" + MEDIA_CHAR + "+?)") + // capture queries (non-greedy)
"(\\s*\\{)" // brace & whitespace
;
var MATCH_REGEXP = /*#__PURE__*/new RegExp("(?:" + PROP_PATT + "|" + MEDIA_PATT + ")", "g");
function transform(rawValue) {
  if (typeof rawValue !== 'string') return rawValue;
  var matches;
  var lastIndex = 0;
  var values = [];

  var _loop = function _loop() {
    var _matches = matches,
        prop = _matches[1],
        colon = _matches[2],
        value = _matches[3],
        imp = _matches[4],
        semi = _matches[5],
        media = _matches[6],
        query = _matches[7],
        brace = _matches[8];

    if (media) {
      values.push(rawValue.slice(lastIndex, matches.index));
      values.push(media);
      mediaTransform(query).forEach(function (v) {
        return values.push(v);
      });
      values.push(brace);
      lastIndex = matches.index + matches[0].length;
    } else {
      var getter = propGetters[prop];

      if (getter) {
        values.push(rawValue.slice(lastIndex, matches.index));
        values.push(function (p) {
          return "" + prop + colon + getter(value)(p) + (imp || '') + semi;
        });
        lastIndex = matches.index + matches[0].length;
      }
    }
  };

  while (matches = MATCH_REGEXP.exec(rawValue)) {
    _loop();
  }

  values.push(rawValue.slice(lastIndex, rawValue.length));
  return values;
} // media query prop/value pairs such as (min-width: 1024px)
// prettier-ignore

var QUERY_REGEXP = /*#__PURE__*/new RegExp("(\\(\\s*)" + ( // open paren, whitespace
"(" + PROP_CHAR + "+)") + // capture prop name
"(\\s*:\\s*)" + // colon & whitespace
"([^\\)]*?)" + // capture prop value (non-greedy)
"(\\s*\\))", // close paren, whitespace
"g");

function mediaTransform(rawValue) {
  var matches;
  var lastIndex = 0;
  var values = [];

  var _loop2 = function _loop2() {
    var _matches2 = matches,
        open = _matches2[1],
        prop = _matches2[2],
        colon = _matches2[3],
        value = _matches2[4],
        close = _matches2[5];
    var getter = mediaGetters[prop];

    if (getter) {
      values.push(rawValue.slice(lastIndex, matches.index));
      values.push(function (p) {
        return "" + open + prop + colon + getter(value)(p) + close;
      });
      lastIndex = matches.index + matches[0].length;
    }
  };

  while (matches = QUERY_REGEXP.exec(rawValue)) {
    _loop2();
  }

  values.push(rawValue.slice(lastIndex, rawValue.length));
  return values;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var join = function join() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join('.');
};

var toVarName = function toVarName(key) {
  return "--" + key.replace(/\./g, '-');
};

var toVarValue = function toVarValue(key, value) {
  return "var(" + toVarName(key) + ", " + value + ")";
};

var toProp = function toProp(key, value) {
  return key + ": " + value + ";";
};

function toCustomPropertiesReferences(values, theme, keys, parent) {
  if (keys === void 0) {
    keys = Object.keys(values);
  }

  var next = Array.isArray(values) ? [] : {};

  for (var i in keys) {
    var key = keys[i];
    var value = values[key];
    var name = join(parent, key);

    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .obj */ .j6)(value)) {
      next[key] = toCustomPropertiesReferences(value, theme, Object.keys(value), name);
      continue;
    }

    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(value)) {
      next[key] = toVarValue(name, value);
      continue;
    }

    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .func */ .Yl)(value)) {
      next[key] = toVarValue(name, (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .cascade */ .Gg)(value, {
        theme: theme
      }));
      continue;
    }
  }

  return next;
}
function toCustomPropertiesDeclarations(values, theme, keys, parent, state) {
  if (keys === void 0) {
    keys = Object.keys(values);
  }

  if (state === void 0) {
    state = {
      value: ''
    };
  }

  for (var i in keys) {
    var key = keys[i];
    var value = values[key];
    var name = join(parent, key);

    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .obj */ .j6)(value)) {
      toCustomPropertiesDeclarations(value, theme, Object.keys(value), name, state);
      continue;
    }

    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(value)) {
      state.value += toProp(toVarName(name), value);
      continue;
    }

    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .func */ .Yl)(value)) {
      state.value += toProp(toVarName(name), (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .cascade */ .Gg)(value, {
        theme: theme
      }));
      continue;
    }
  }

  return state.value;
}

var STORAGE_KEY = 'xstyled-color-mode';

var isLocalStorageAvailable = typeof window !== 'undefined' && /*#__PURE__*/function () {
  try {
    var key = 'xstyled-test-key';
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch (err) {
    return false;
  }
}();

var storage = isLocalStorageAvailable ? {
  get: function get() {
    return window.localStorage.getItem(STORAGE_KEY);
  },
  set: function set(value) {
    window.localStorage.setItem(STORAGE_KEY, value);
  },
  clear: function clear() {
    return window.localStorage.removeItem(STORAGE_KEY);
  }
} : {
  get: function get() {
    return null;
  },
  set: function set() {},
  clear: function clear() {}
};
var COLOR_MODE_CLASS_PREFIX = 'xstyled-color-mode-';

var getColorModeClassName = function getColorModeClassName(mode) {
  return "" + COLOR_MODE_CLASS_PREFIX + mode;
};

var XSTYLED_COLORS_PREFIX = 'xstyled-colors';
var SYSTEM_MODES = ['light', 'dark'];

function getModeTheme(theme, mode) {
  return _extends({}, theme, {
    colors: _extends({}, theme.colors, theme.colors.modes[mode])
  });
}

var getMediaQuery = function getMediaQuery(query) {
  return "@media " + query;
};

var getColorModeQuery = function getColorModeQuery(mode) {
  return "(prefers-color-scheme: " + mode + ")";
};

function checkHasColorModes(theme) {
  return Boolean(theme && theme.colors && theme.colors.modes);
}

function checkHasCustomPropertiesEnabled(theme) {
  return Boolean(theme && (theme.useCustomProperties === undefined || theme.useCustomProperties));
}

function checkHasMediaQueryEnabled(theme) {
  return Boolean(theme && (theme.useColorSchemeMediaQuery === undefined || theme.useColorSchemeMediaQuery));
}

function getInitialColorModeName(theme) {
  return theme.initialColorModeName || 'default';
}

function getDefaultColorModeName(theme) {
  return theme.defaultColorModeName || getInitialColorModeName(theme);
}

function getUsedColorKeys(modes) {
  var keys = [];

  for (var key in modes) {
    keys = [].concat(keys, Object.keys(modes[key]));
  }

  return keys;
}

function createColorStyles(theme, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$targetSelector = _ref.targetSelector,
      targetSelector = _ref$targetSelector === void 0 ? 'body' : _ref$targetSelector;

  if (!checkHasColorModes(theme)) return null;

  var _theme$colors = theme.colors,
      modes = _theme$colors.modes,
      colors = _objectWithoutPropertiesLoose(_theme$colors, ["modes"]);

  var colorKeys = getUsedColorKeys(modes);
  var styles = toCustomPropertiesDeclarations(colors, theme, colorKeys, XSTYLED_COLORS_PREFIX);

  function getModePropertiesDeclarations(mode) {
    var modeTheme = getModeTheme(theme, mode);

    var _modeTheme$colors = modeTheme.colors,
        modes = _modeTheme$colors.modes,
        colors = _objectWithoutPropertiesLoose(_modeTheme$colors, ["modes"]);

    return toCustomPropertiesDeclarations(_extends({}, colors, modes[mode]), modeTheme, colorKeys, XSTYLED_COLORS_PREFIX);
  }

  if (theme.useColorSchemeMediaQuery !== false) {
    SYSTEM_MODES.forEach(function (mode) {
      if (modes[mode]) {
        var mediaQuery = getMediaQuery(getColorModeQuery(mode));
        styles += mediaQuery + "{" + getModePropertiesDeclarations(mode) + "}";
      }
    });
  }

  var initialModeName = getInitialColorModeName(theme);
  [initialModeName].concat(Object.keys(modes)).forEach(function (mode) {
    var key = "&." + getColorModeClassName(mode);
    styles += key + "{" + getModePropertiesDeclarations(mode) + "}";
  });
  return targetSelector + "{" + styles + "}";
}

function getSystemModeMql(mode) {
  if (typeof window === 'undefined' || window.matchMedia === undefined) {
    return null;
  }

  var query = getColorModeQuery(mode);
  return window.matchMedia(query);
}

function useSystemMode(theme) {
  var configs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (!checkHasMediaQueryEnabled(theme)) return [];
    return SYSTEM_MODES.map(function (mode) {
      if (!checkHasColorModes(theme)) return null;
      if (!theme.colors.modes[mode]) return null;
      var mql = getSystemModeMql(mode);
      return mql ? {
        mode: mode,
        mql: mql
      } : null;
    }).filter(Boolean);
  }, [theme]);

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
    var config = configs.find(function (config) {
      return config.mql.matches;
    });
    return config ? config.mode : null;
  }),
      systemMode = _React$useState[0],
      setSystemMode = _React$useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var cleans = configs.map(function (_ref2) {
      var mode = _ref2.mode,
          mql = _ref2.mql;

      var handler = function handler(_ref3) {
        var matches = _ref3.matches;

        if (matches) {
          setSystemMode(mode);
        } else {
          setSystemMode(function (previousMode) {
            return previousMode === mode ? null : mode;
          });
        }
      };

      mql.addEventListener('change', handler);
      return function () {
        return mql.removeEventListener('change', handler);
      };
    });
    return function () {
      return cleans.forEach(function (clean) {
        return clean();
      });
    };
  });
  return systemMode;
}

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
function useColorModeState(theme, _temp2) {
  var _ref4 = _temp2 === void 0 ? {} : _temp2,
      target = _ref4.target;

  var systemMode = useSystemMode(theme);
  var defaultColorMode = getDefaultColorModeName(theme);
  var initialColorMode = getInitialColorModeName(theme);

  var _React$useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
    if (!checkHasColorModes(theme)) return null;
    return defaultColorMode;
  }),
      mode = _React$useState2[0],
      setMode = _React$useState2[1]; // Add mode className


  var customPropertiesEnabled = checkHasCustomPropertiesEnabled(theme);
  var manualSetRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var manuallySetMode = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value) {
    manualSetRef.current = true;
    setMode(value);
  }, []); // Set initial color mode in lazy

  useIsomorphicLayoutEffect(function () {
    if (!checkHasColorModes(theme)) return;
    var storedMode = storage.get();
    var initialMode = storedMode || systemMode || defaultColorMode;

    if (mode !== initialMode) {
      setMode(storedMode || systemMode || defaultColorMode);
    }
  }, []); // Store mode preference

  useIsomorphicLayoutEffect(function () {
    if (manualSetRef.current) {
      if (mode) {
        storage.set(mode);
      } else {
        storage.clear();
      }
    }
  }, [mode]); // Sync system mode

  useIsomorphicLayoutEffect(function () {
    var storedMode = storage.get();
    if (storedMode) return;
    var targetMode = systemMode || defaultColorMode;
    if (targetMode === mode) return;
    setMode(targetMode);
  }, [mode, systemMode, defaultColorMode]); // Add and remove class names

  useIsomorphicLayoutEffect(function () {
    if (!mode) return undefined;
    if (!customPropertiesEnabled) return undefined;
    var stored = storage.get();
    var initial = initialColorMode !== mode;
    if (!stored && !initial) return undefined;
    var className = getColorModeClassName(mode);
    var usedTarget = target || document.body;
    usedTarget.classList.add(className);
    return function () {
      usedTarget.classList.remove(className);
    };
  }, [customPropertiesEnabled, target, mode, initialColorMode]);
  return [mode, manuallySetMode];
}
function useColorModeTheme(theme, mode) {
  var _React$useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(mode),
      initialMode = _React$useState3[0];

  var customPropertiesTheme = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (!initialMode) return null;
    if (!checkHasCustomPropertiesEnabled(theme)) return null;
    if (!checkHasColorModes(theme)) return theme;

    var _theme$colors2 = theme.colors,
        modes = _theme$colors2.modes,
        colors = _objectWithoutPropertiesLoose(_theme$colors2, ["modes"]);

    var colorKeys = getUsedColorKeys(modes);
    return _extends({}, theme, {
      colors: _extends({}, colors, toCustomPropertiesReferences(colors, theme, colorKeys, XSTYLED_COLORS_PREFIX), {
        modes: modes
      }),
      __rawColors: theme.colors
    });
  }, [initialMode, theme]);
  var swapModeTheme = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (!mode) return null;
    if (checkHasCustomPropertiesEnabled(theme)) return null;
    if (!checkHasColorModes(theme)) return theme;

    if (mode === getInitialColorModeName(theme)) {
      return _extends({}, theme, {
        __colorMode: mode
      });
    }

    return _extends({}, theme, {
      colors: _extends({}, theme.colors, theme.colors.modes[mode]),
      __colorMode: mode,
      __rawColors: theme.colors
    });
  }, [theme, mode]);
  return customPropertiesTheme || swapModeTheme;
}
var ColorModeContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function useColorMode() {
  var colorModeState = useContext(ColorModeContext);

  if (!colorModeState) {
    throw new Error("[useColorMode] requires the ColorModeProvider component");
  }

  return colorModeState;
}
function createColorModeProvider(_ref5) {
  var ThemeContext = _ref5.ThemeContext,
      ThemeProvider = _ref5.ThemeProvider,
      ColorModeStyle = _ref5.ColorModeStyle;

  function ColorModeProvider(_ref6) {
    var children = _ref6.children,
        target = _ref6.target,
        targetSelector = _ref6.targetSelector;
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);

    if (!theme) {
      throw new Error('[ColorModeProvider] requires ThemeProvider upper in the tree');
    }

    var colorState = useColorModeState(theme, {
      target: target
    });
    var colorModeTheme = useColorModeTheme(theme, colorState[0]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ColorModeStyle, {
      targetSelector: targetSelector
    }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ThemeProvider, {
      theme: colorModeTheme
    }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ColorModeContext.Provider, {
      value: colorState
    }, children)));
  }

  return ColorModeProvider;
}

function getInitScript(_temp3) {
  var _ref7 = _temp3 === void 0 ? {} : _temp3,
      _ref7$target = _ref7.target,
      target = _ref7$target === void 0 ? 'document.body' : _ref7$target;

  return "(function() { try {\n    var mode = localStorage.getItem('" + STORAGE_KEY + "');\n    if (mode) " + target + ".classList.add('" + COLOR_MODE_CLASS_PREFIX + "' + mode);\n  } catch (e) {} })();";
}

function getColorModeInitScriptElement(options) {
  return createElement("script", {
    key: "xstyled-color-mode-init",
    dangerouslySetInnerHTML: {
      __html: getInitScript(options)
    }
  });
}
function getColorModeInitScriptTag(options) {
  return "<script>" + getInitScript(options) + "</script>";
}


//# sourceMappingURL=core.esm.js.map


/***/ }),

/***/ 4337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FgM": function() { return /* binding */ useTheme; },
/* harmony export */   "ivY": function() { return /* binding */ css; },
/* harmony export */   "rdp": function() { return /* binding */ useColor; },
/* harmony export */   "xuv": function() { return /* binding */ Box; }
/* harmony export */ });
/* unused harmony exports ColorModeProvider, Preflight, createGlobalStyle, createX, useAngle, useAnimation, useBorder, useBorderColor, useBorderStyle, useBorderWidth, useBreakpoint, useBreakpoints, useDown, useDuration, useFont, useFontSize, useFontWeight, useInset, useLetterSpacing, useLineHeight, usePercent, usePx, useRadius, useRingWidth, useShadow, useSize, useSpace, useTh, useTimingFunctions, useTransform, useTransition, useTransitionProperty, useUp, useZIndex, x */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1096);
/* harmony import */ var _xstyled_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4583);
/* harmony import */ var _xstyled_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1278);
/* harmony import */ var _xstyled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7248);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);









/* eslint-disable no-continue, no-loop-func, no-cond-assign */
function css() {
  var scCssArgs = styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css.apply */ .iv.apply(void 0, arguments);
  var flattenedArgs = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_2__/* .flattenStrings */ .J)(scCssArgs);
  return flattenedArgs.map(_xstyled_core__WEBPACK_IMPORTED_MODULE_3__/* .transform */ .vs);
}

var createGlobalStyle = function createGlobalStyle() {
  // @ts-ignore
  return createGlobalStyle$1([css.apply(void 0, arguments)]);
};

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

/* eslint-disable no-continue, no-loop-func, no-cond-assign */
var tags = /*#__PURE__*/Object.keys(styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP);
var createX = function createX(generator) {
  // @ts-ignore
  var x = {
    extend: function extend() {
      for (var _len = arguments.length, generators = new Array(_len), _key = 0; _key < _len; _key++) {
        generators[_key] = arguments[_key];
      }

      return createX(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__/* .compose.apply */ .qCK.apply(void 0, [generator].concat(generators)));
    }
  };
  tags.forEach(function (tag) {
    // @ts-ignore
    x[tag] = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(tag).withConfig({
      shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
        if (typeof prop === 'string' && generator.meta.props.includes(prop)) return false;
        return defaultValidatorFn(prop);
      }
    })(function () {
      return ["&&{", generator, "}"];
    });
  });
  return x;
};

var x = /*#__PURE__*/createX(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__/* .system */ .ByQ); // Retro-compatibility

var Box = x.div;

var _templateObject;

function getCreateStyle(baseCreateStyle) {
  // @ts-ignore
  var createStyle = function createStyle() {
    return baseCreateStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["", ""])), css.apply(void 0, arguments));
  };

  createStyle.attrs = function (attrs) {
    var nextCreateStyle = baseCreateStyle.attrs(attrs);
    return getCreateStyle(nextCreateStyle);
  };

  createStyle.withConfig = function (config) {
    var nextCreateStyle = baseCreateStyle.withConfig(config);
    return getCreateStyle(nextCreateStyle);
  };

  return createStyle;
}

var styled = function styled(component) {
  return getCreateStyle((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(component));
}; // @ts-ignore

styled.box = /*#__PURE__*/styled(x.div);
Object.keys(styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP).forEach(function (key) {
  // @ts-ignore
  styled[key] = styled(key); // @ts-ignore

  styled[key + "Box"] = styled(x[key]);
});

var _templateObject$1;
var ColorModeStyle = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .createGlobalStyle */ .vJ)(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["", ""])), function (p) {
  return (0,_xstyled_core__WEBPACK_IMPORTED_MODULE_3__/* .createColorStyles */ .uy)(p.theme, {
    targetSelector: p.targetSelector
  });
});
var ColorModeProvider = /*#__PURE__*/(0,_xstyled_core__WEBPACK_IMPORTED_MODULE_3__/* .createColorModeProvider */ .Q2)({
  ThemeContext: styled_components__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .Ni,
  ThemeProvider: styled_components__WEBPACK_IMPORTED_MODULE_1__/* .ThemeProvider */ .f6,
  ColorModeStyle: ColorModeStyle
});

var useTheme = function useTheme() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .Ni);
};

var createUseGetter = function createUseGetter(getter) {
  return function (value, defaultValue) {
    var theme = useTheme();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
      return getter(value, defaultValue)({
        theme: theme
      });
    }, [value, defaultValue, theme]);
  };
};

var useTh = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th);
var useAngle = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.angle);
var useAnimation = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.animation);
var useBorder = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.border);
var useBorderColor = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.borderColor);
var useBorderStyle = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.borderStyle);
var useBorderWidth = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.borderWidth);
var useColor = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.color);
var useDuration = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.duration);
var useFont = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.font);
var useFontSize = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.fontSize);
var useFontWeight = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.fontWeight);
var useInset = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.inset);
var useLetterSpacing = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.letterSpacing);
var useLineHeight = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.lineHeight);
var usePercent = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.percent);
var usePx = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.px);
var useRadius = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.radius);
var useRingWidth = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.ringWidth);
var useShadow = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.shadow);
var useSize = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.size);
var useSpace = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.space);
var useTimingFunctions = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.timingFunctions);
var useTransform = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.transform);
var useTransition = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.transition);
var useTransitionProperty = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.transitionProperty);
var useZIndex = /*#__PURE__*/createUseGetter(_xstyled_system__WEBPACK_IMPORTED_MODULE_4__.th.zIndex);

function useBreakpoints() {
  return useThemeBreakpoints(useTheme());
}
function useBreakpoint() {
  return useThemeBreakpoint(useTheme());
}
function useUp(key) {
  return useThemeUp(useTheme(), key);
}
function useDown(key) {
  return useThemeDown(useTheme(), key);
}

var Preflight = /*#__PURE__*/(0,_xstyled_system__WEBPACK_IMPORTED_MODULE_4__/* .createPreflight */ .A9i)({
  createGlobalStyle: styled_components__WEBPACK_IMPORTED_MODULE_1__/* .createGlobalStyle */ .vJ
});

/* harmony default export */ __webpack_exports__["ZPm"] = (styled);

//# sourceMappingURL=styled-components.esm.js.map


/***/ }),

/***/ 7248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9i": function() { return /* binding */ createPreflight; },
/* harmony export */   "ByQ": function() { return /* binding */ system; },
/* harmony export */   "CkN": function() { return /* binding */ getTransform; },
/* harmony export */   "Dpt": function() { return /* binding */ getLineHeight; },
/* harmony export */   "EL6": function() { return /* binding */ getBreakpointMax; },
/* harmony export */   "H5b": function() { return /* binding */ getRadius; },
/* harmony export */   "KKi": function() { return /* binding */ getZIndex; },
/* harmony export */   "Lq4": function() { return /* binding */ getColor; },
/* harmony export */   "M5s": function() { return /* binding */ getInset; },
/* harmony export */   "O8": function() { return /* binding */ getAnimation; },
/* harmony export */   "Onc": function() { return /* binding */ getFontWeight; },
/* harmony export */   "Pjv": function() { return /* binding */ getSpace; },
/* harmony export */   "Xj4": function() { return /* binding */ getShadow; },
/* harmony export */   "_Dl": function() { return /* binding */ getTimingFunction; },
/* harmony export */   "apW": function() { return /* binding */ getSize; },
/* harmony export */   "aqw": function() { return /* binding */ getBorderWidth; },
/* harmony export */   "cgZ": function() { return /* binding */ getLetterSpacing; },
/* harmony export */   "dR$": function() { return /* binding */ getBorderStyle; },
/* harmony export */   "fkS": function() { return /* binding */ getTransitionProperty; },
/* harmony export */   "g9Y": function() { return /* binding */ getDuration; },
/* harmony export */   "ler": function() { return /* binding */ getBreakpoints; },
/* harmony export */   "oSz": function() { return /* binding */ getBreakpointMin; },
/* harmony export */   "qCK": function() { return /* binding */ compose; },
/* harmony export */   "qTy": function() { return /* binding */ getFont; },
/* harmony export */   "th": function() { return /* binding */ th; },
/* harmony export */   "ubX": function() { return /* binding */ getBorder; },
/* harmony export */   "ush": function() { return /* binding */ getTransition; },
/* harmony export */   "yvh": function() { return /* binding */ getFontSize; }
/* harmony export */ });
/* unused harmony exports aliasColor, alignContent, alignItems, alignSelf, animation, animations, appearance, background, backgroundAttachment, backgroundClip, backgroundColor, backgroundImage, backgroundPosition, backgroundRepeat, backgroundSize, backgrounds, between, border, borderBottom, borderBottomColor, borderBottomWidth, borderCollapse, borderColor, borderLeft, borderLeftColor, borderLeftWidth, borderRadius, borderRight, borderRightColor, borderRightWidth, borderStyle, borderTop, borderTopColor, borderTopWidth, borderWidth, borders, bottom, boxShadow, boxSizing, breakpoints, col, color, columnGap, container, createStyleGenerator, cursor, defaultTheme, display, divideColor, divideStyle, divideX, divideXReverse, divideY, divideYReverse, down, effects, fill, flex, flexBasis, flexDirection, flexGrow, flexShrink, flexWrap, flexboxGrids, flexboxes, float, fontFamily, fontSize, fontStyle, fontWeight, gap, generateHexAlphaVariants, getAngle, getBorderColor, getPercent, getPx, getRingWidth, gradientFrom, gradientTo, gradientVia, gridArea, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumn, gridRow, gridTemplateAreas, gridTemplateColumns, gridTemplateRows, grids, height, interactivity, justifyContent, justifyItems, justifySelf, layout, left, letterSpacing, lineHeight, listStylePosition, listStyleType, margin, marginBottom, marginLeft, marginRight, marginTop, maxHeight, maxWidth, minHeight, minWidth, mx, my, objectFit, opacity, order, outline, outlineColor, outlineStyle, outlineWidth, overflow, overflowX, overflowY, overscrollBehavior, padding, paddingBottom, paddingLeft, paddingRight, paddingTop, pointerEvents, position, px, py, resize, right, ring, ringColor, ringInset, rotate, row, rowGap, rpxTransformers, scale, scaleX, scaleY, sizing, skewX, skewY, space, spaceX, spaceXReverse, spaceY, spaceYReverse, stroke, style, svg, tableLayout, tables, textAlign, textDecoration, textOverflow, textShadow, textTransform, themeGetter, top, transform, transformOrigin, transforms, transition, transitionDelay, transitionDuration, transitionProperty, transitionTimingFunction, transitions, translateX, translateY, typography, up, userSelect, verticalAlign, visibility, whiteSpace, width, zIndex */
/* harmony import */ var _xstyled_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4583);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var round = function round(value) {
  return Math.round(value * Math.pow(10, 4)) / Math.pow(10, 4);
};

var unit = function unit(_unit) {
  return function (value) {
    return (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .num */ .OK)(value) && value !== 0 ? "" + value + _unit : value;
  };
};
var ms = /*#__PURE__*/unit('ms');
var px = /*#__PURE__*/unit('px');
var deg = /*#__PURE__*/unit('deg');

var pxToRem = function pxToRem(value, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$rootFontSize = _ref.rootFontSize,
      rootFontSize = _ref$rootFontSize === void 0 ? 16 : _ref$rootFontSize;

  return round(value / rootFontSize);
};

var remPx = function remPx(value, options) {
  return (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .num */ .OK)(value) && value !== 0 ? pxToRem(value, options) + "rem" : value;
};
var rpx = function rpx(value, options) {
  if (!(0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)(value) || value.length < 4) return value;
  var unit = value.slice(-3);
  if (unit !== 'rpx') return value;
  var n = Number(value.slice(0, value.length - 3));
  if (n === 0) return 0;
  return pxToRem(n, options) + "rem";
};
var percent = function percent(n) {
  return (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .num */ .OK)(n) && n !== 0 && n >= -1 && n <= 1 ? round(n * 100) + "%" : n;
};

function toNegative(value) {
  if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)(value)) return "-" + value;
  return value * -1;
}

var transformNegative = function transformNegative(_, _ref2) {
  var rawValue = _ref2.rawValue,
      variants = _ref2.variants,
      props = _ref2.props;

  if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)(rawValue)) {
    var _neg = rawValue.startsWith('-');

    var absoluteValue = _neg ? rawValue.substr(1) : rawValue;
    var variantValue = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .getThemeValue */ .u_)(props, absoluteValue, variants);

    var _value = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(variantValue) ? variantValue : absoluteValue;

    return _neg ? toNegative(_value) : _value;
  }

  var abs = Math.abs(rawValue);
  var neg = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .negative */ .pd)(rawValue);
  var value = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(variants && variants[abs]) ? variants[abs] : abs;
  return neg ? toNegative(value) : value;
};

function getBreakpoints(props) {
  var themeBreakpoints = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .getThemeValue */ .u_)(props, 'screens');
  if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(themeBreakpoints)) return themeBreakpoints;
  return {};
}
var mediaMinWidth = function mediaMinWidth(value) {
  return value ? "@media (min-width: " + value + ")" : null;
};
var mediaMaxWidth = function mediaMaxWidth(value) {
  return value ? "@media (max-width: " + value + ")" : null;
};
var mediaBetweenWidth = function mediaBetweenWidth(min, max) {
  return min && max ? "@media (min-width: " + min + ") and (max-width: " + max + ")" : null;
};
/**
 * Minimum breakpoint width.
 * Null for the smallest breakpoint.
 */

var getBreakpointMin = function getBreakpointMin(breakpoints, key) {
  var value = breakpoints[key];
  return value === 0 ? null : px(value);
};
/**
 * Maximum breakpoint width. Null for the largest (last) breakpoint.
 * The maximum value is calculated as the minimum of the next one less 0.02px
 * to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.
 * See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
 * Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
 * See https://bugs.webkit.org/show_bug.cgi?id=178261
 */

var getBreakpointMax = function getBreakpointMax(breakpoints, key) {
  var breakPoint = breakpoints[key];
  return breakPoint === 0 ? null : px(breakPoint - 0.02);
};

var defaultStates = {
  motionSafe: '@media (prefers-reduced-motion: no-preference)',
  motionReduce: '@media (prefers-reduced-motion: reduce)',
  first: '&:first-child',
  last: '&:last-child',
  odd: '&:odd',
  even: '&:even',
  visited: '&:visited',
  checked: '&:checked',
  focusWithin: '&:focus-within',
  hover: '&:hover',
  focus: '&:focus',
  focusVisible: '&:focus-visible',
  active: '&:active',
  disabled: '&:disabled',
  placeholder: '&::placeholder'
};

var defaultStateKeys = /*#__PURE__*/Object.keys(defaultStates);
var cacheSupported = typeof Map !== 'undefined' && typeof WeakMap !== 'undefined';
var caches = cacheSupported ? /*#__PURE__*/new WeakMap() : null;

function getThemeCache(theme) {
  if (caches === null) return null;
  if (caches.has(theme)) return caches.get(theme);
  var cache = {};
  caches.set(theme, cache);
  return cache;
}

var noopCache = {
  has: function has() {
    return false;
  },
  set: function set() {},
  get: function get() {}
};

function getCacheNamespace(theme, namespace) {
  if (!theme) return noopCache;
  var cache = getThemeCache(theme);
  if (!cache || !theme) return noopCache;
  cache[namespace] = cache[namespace] || new Map();
  return cache[namespace];
}

var themeGetterId = 0;
var SPACES = /\s+/;
var themeGetter = function themeGetter(_ref) {
  var name = _ref.name,
      defaultTransform = _ref.transform,
      key = _ref.key,
      defaultVariants = _ref.defaultVariants,
      compose = _ref.compose,
      shorthand = _ref.shorthand;
  var id = themeGetterId++;

  var getter = function getter(value, defaultValue) {
    return function (props) {
      var res = value;
      if (!(0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)(value) && !(0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .num */ .OK)(value) && value !== true) return res;
      var cacheKey = value + "-" + defaultValue;
      var cache = getCacheNamespace(props.theme, "__themeGetter" + id);
      if (cache.has(cacheKey)) return cache.get(cacheKey);

      var getValue = function getValue(value) {
        var localDefaultValue = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(defaultValue) ? defaultValue : value;
        var res = value;
        var variants = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(key) ? (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .getThemeValue */ .u_)(props, key) : null;
        variants = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(variants) ? variants : defaultVariants;

        if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(variants)) {
          // @ts-ignore
          res = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .getThemeValue */ .u_)(props, value === true ? 'default' : value, variants);
          res = Array.isArray(res) ? res.join(',') : res;
        }

        var rawValue = value;

        if (!(0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(res)) {
          rawValue = localDefaultValue;
          res = localDefaultValue;
        }

        var transform = (name && props.theme && props.theme.transformers ? props.theme.transformers[name] : null) || defaultTransform;

        if (transform) {
          res = transform(res, {
            rawValue: rawValue,
            variants: variants,
            props: props
          });
        }

        return compose ? compose(res)(props) : res;
      };

      if (shorthand && (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)(value)) {
        var values = value.split(SPACES); // @ts-ignore

        res = values.map(function (value) {
          return getValue(value);
        }).join(' ');
      } else {
        res = getValue(value);
      }

      cache.set(cacheKey, res);
      return res;
    };
  };

  getter.meta = {
    name: name,
    transform: defaultTransform
  };
  return getter;
};
function createStyleGenerator(getStyle, props, generators) {
  var generator = getStyle;
  generator.meta = {
    props: props,
    getStyle: generator,
    generators: generators
  };

  generator.apply = function (values) {
    return function (_ref2) {
      var theme = _ref2.theme;
      return generator(_extends({
        theme: theme
      }, values));
    };
  };

  return generator;
}

function getMedias(props) {
  var breakpoints = getBreakpoints(props);
  var medias = {};

  for (var breakpoint in breakpoints) {
    medias[breakpoint] = mediaMinWidth(getBreakpointMin(breakpoints, breakpoint));
  }

  return medias;
}

function getCachedMedias(props, cache) {
  if (cache.has('_medias')) {
    return cache.get('_medias');
  }

  var medias = getMedias(props);
  cache.set('_medias', medias);
  return medias;
}

function reduceBreakpoints(props, values, getStyle, cache) {
  if (getStyle === void 0) {
    getStyle = _xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .identity */ .yR;
  }

  var medias = cache ? getCachedMedias(props, cache) : getMedias(props);
  var styles = {};

  for (var breakpoint in values) {
    var _style = getStyle(values[breakpoint]);

    if (_style === null) continue;
    var media = medias[breakpoint];

    if (media === null) {
      styles = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TS)(styles, _style);
    } else {
      styles[media] = styles[media] ? (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)(styles[media], _style) : _style;
    }
  }

  return styles;
}

function styleFromValue(mixin, value, props, themeGet, cache) {
  if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .obj */ .j6)(value)) return null;
  if (cache.has(value)) return cache.get(value);
  var computedValue = themeGet(value)(props);
  var style = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .cascade */ .Gg)(mixin(computedValue), props);
  cache.set(value, style);
  return style;
}

function getStyleFactory(prop, mixin, themeGet) {
  return function getStyle(props) {
    var value = props[prop];
    if (!(0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(value)) return null;
    var cache = getCacheNamespace(props.theme, prop);

    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .obj */ .j6)(value)) {
      return reduceBreakpoints(props, value, function (breakpointValue) {
        return styleFromValue(mixin, breakpointValue, props, themeGet, cache);
      }, cache);
    }

    return styleFromValue(mixin, value, props, themeGet, cache);
  };
}

function scopeStyleGetter(selector, getStyle) {
  return function (props) {
    var _ref3;

    var result = getStyle(props);
    if (result === null) return result;
    return _ref3 = {}, _ref3[selector] = result, _ref3;
  };
}

function indexGeneratorsByProp(styles) {
  var index = {};

  for (var i = 0; i < styles.length; i++) {
    var _style2 = styles[i];

    if (_style2 && _style2.meta) {
      for (var j = 0; j < _style2.meta.props.length; j++) {
        var prop = _style2.meta.props[j];
        index[prop] = _style2;
      }
    }
  }

  return index;
}

function sortStyles(styles, medias) {
  for (var key in medias) {
    var mediaValue = medias[key];
    var s = styles[mediaValue];
    if (!s) continue;
    delete styles[mediaValue];
    styles[mediaValue] = s;
  }

  return styles;
}

function compose() {
  var flatGenerators = [];

  for (var _len = arguments.length, generators = new Array(_len), _key = 0; _key < _len; _key++) {
    generators[_key] = arguments[_key];
  }

  generators.forEach(function (gen) {
    (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .warn */ .ZK)(Boolean(gen), "Undefined generator in \"compose\" method");
    if (!gen) return;

    if (gen.meta.generators) {
      flatGenerators = [].concat(flatGenerators, gen.meta.generators);
    } else {
      flatGenerators.push(gen);
    }
  });
  var generatorsByProp = indexGeneratorsByProp(flatGenerators);

  function getStyle(props, sort) {
    if (sort === void 0) {
      sort = true;
    }

    var styles = {};

    for (var key in props) {
      var generator = generatorsByProp[key];

      if (generator) {
        var _style3 = generator.meta.getStyle(props, false);

        (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TS)(styles, _style3);
      }
    }

    if (!sort) return styles;
    var medias = getCachedMedias(props, getCacheNamespace(props.theme, '__medias'));
    return sortStyles(styles, medias);
  }

  var props = flatGenerators.reduce(function (allProps, generator) {
    return [].concat(allProps, generator.meta.props);
  }, []);
  return createStyleGenerator(getStyle, props, generators);
}

var getMixinFromCSSProperties = function getMixinFromCSSProperties(properties) {
  return function (value) {
    var _ref4;

    if (!(0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)(value) && !(0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .num */ .OK)(value)) return null;
    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)(properties)) return _ref4 = {}, _ref4[properties] = value, _ref4;
    var style = {};

    for (var key in properties) {
      style[properties[key]] = value;
    }

    return style;
  };
};

var getMixinFromCSSProperty = function getMixinFromCSSProperty(cssProperty) {
  if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .func */ .Yl)(cssProperty)) return cssProperty;
  return getMixinFromCSSProperties(cssProperty);
};

function style(_ref5) {
  var prop = _ref5.prop,
      cssProperty = _ref5.cssProperty,
      key = _ref5.key,
      transform = _ref5.transform,
      themeGet = _ref5.themeGet,
      _ref5$states = _ref5.states,
      states = _ref5$states === void 0 ? defaultStates : _ref5$states;

  if (Array.isArray(prop)) {
    var _mixin = cssProperty ? getMixinFromCSSProperty(cssProperty) : cssProperty;

    var _generators = prop.map(function (prop) {
      return style({
        prop: prop,
        cssProperty: _mixin,
        key: key,
        transform: transform,
        themeGet: themeGet
      });
    }); // @ts-ignore


    return compose.apply(void 0, _generators);
  }

  var mixin = getMixinFromCSSProperty(cssProperty || [prop]);
  themeGet = themeGet || themeGetter({
    key: key,
    transform: transform
  });
  var capitalizedProp = prop.charAt(0).toUpperCase() + prop.slice(1);
  var generators = [];
  var stateNames = states === defaultStates ? defaultStateKeys : Object.keys(states);

  for (var i = 0; i < stateNames.length; i++) {
    var stateName = stateNames[i];
    var stateProp = "" + stateName + capitalizedProp;

    var _getStyle = scopeStyleGetter(states[stateName], getStyleFactory(stateProp, mixin, themeGet));

    var _generator = createStyleGenerator(_getStyle, [stateProp]);

    generators.push(_generator);
  }

  var getStyle = getStyleFactory(prop, mixin, themeGet);
  var generator = createStyleGenerator(getStyle, [prop]);
  generators.push(generator); // @ts-ignore

  return compose.apply(void 0, generators);
}

var getAnimation = /*#__PURE__*/themeGetter({
  name: 'animation',
  key: 'animations'
});
var animation = /*#__PURE__*/style({
  prop: 'animation',
  themeGet: getAnimation
});
var animations = /*#__PURE__*/compose(animation);

var getColor = /*#__PURE__*/themeGetter({
  name: 'color',
  key: 'colors'
});

var gradientBackgrounds = {
  'gradient-to-t': 'linear-gradient(to top, var(--x-gradient-stops))',
  'gradient-to-tr': 'linear-gradient(to top right, var(--x-gradient-stops))',
  'gradient-to-r': 'linear-gradient(to right, var(--x-gradient-stops))',
  'gradient-to-br': 'linear-gradient(to bottom right, var(--x-gradient-stops))',
  'gradient-to-b': 'linear-gradient(to bottom, var(--x-gradient-stops))',
  'gradient-to-bl': 'linear-gradient(to bottom left, var(--x-gradient-stops))',
  'gradient-to-l': 'linear-gradient(to left, var(--x-gradient-stops))',
  'gradient-to-tl': 'linear-gradient(to top left, var(--x-gradient-stops))'
};
var background = /*#__PURE__*/style({
  prop: 'background',
  cssProperty: function cssProperty(value) {
    return {
      background: gradientBackgrounds[value] || value
    };
  }
});
var backgroundColor = /*#__PURE__*/style({
  prop: ['backgroundColor', 'bg'],
  cssProperty: 'backgroundColor',
  themeGet: getColor
});
var backgroundImage = /*#__PURE__*/style({
  prop: 'backgroundImage',
  cssProperty: function cssProperty(value) {
    return {
      backgroundImage: gradientBackgrounds[value] || value
    };
  }
});
var backgroundSize = /*#__PURE__*/style({
  prop: 'backgroundSize'
});
var backgroundPosition = /*#__PURE__*/style({
  prop: 'backgroundPosition'
});
var backgroundRepeat = /*#__PURE__*/style({
  prop: 'backgroundRepeat'
});
var backgroundAttachment = /*#__PURE__*/style({
  prop: 'backgroundAttachment'
});
var backgroundClip = /*#__PURE__*/style({
  prop: 'backgroundClip',
  cssProperty: ['backgroundClip', '-webkitBackgroundClip']
});
var gradientFrom = /*#__PURE__*/style({
  prop: 'gradientFrom',
  themeGet: getColor,
  cssProperty: function cssProperty(value) {
    return {
      '--x-gradient-from': value,
      '--x-gradient-stops': 'var(--x-gradient-from), var(--x-gradient-to, transparent)'
    };
  }
});
var gradientVia = /*#__PURE__*/style({
  prop: 'gradientVia',
  themeGet: getColor,
  cssProperty: function cssProperty(value) {
    return {
      '--x-gradient-stops': "var(--x-gradient-from), " + value + ", var(--x-gradient-to, transparent)"
    };
  }
});
var gradientTo = /*#__PURE__*/style({
  prop: 'gradientTo',
  themeGet: getColor,
  cssProperty: '--x-gradient-to'
});
var backgrounds = /*#__PURE__*/compose(background, backgroundColor, backgroundImage, backgroundSize, backgroundPosition, backgroundRepeat, backgroundAttachment, backgroundClip, gradientFrom, gradientVia, gradientTo);

var getPx = /*#__PURE__*/themeGetter({
  name: 'px',
  transform: function transform(value, _ref) {
    var _props$theme$settings, _props$theme, _props$theme$settings2;

    var props = _ref.props;
    var rootFontSize = (_props$theme$settings = props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : (_props$theme$settings2 = _props$theme.settings) == null ? void 0 : _props$theme$settings2.rootFontSize) != null ? _props$theme$settings : undefined;
    var num = Number(value);
    return px(rpx(Number.isNaN(num) ? value : num, {
      rootFontSize: rootFontSize
    }));
  }
});
var getDuration = /*#__PURE__*/themeGetter({
  name: 'duration',
  key: 'durations',
  transform: function transform(value) {
    var num = Number(value);
    return ms(Number.isNaN(num) ? value : num);
  }
});
var getAngle = /*#__PURE__*/themeGetter({
  name: 'angle',
  transform: function transform(value) {
    var num = Number(value);
    return deg(Number.isNaN(num) ? value : num);
  }
});
var getPercent = /*#__PURE__*/themeGetter({
  name: 'percent',
  transform: percent,
  compose: getPx
});

var getBorder = /*#__PURE__*/themeGetter({
  name: 'border',
  key: 'borders',
  transform: function transform(n) {
    return (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .num */ .OK)(n) && n > 0 ? px(n) + " solid" : n;
  }
});
var getBorderWidth = /*#__PURE__*/themeGetter({
  name: 'borderWidth',
  key: 'borderWidths',
  compose: getPx,
  shorthand: true
});
var getBorderColor = /*#__PURE__*/themeGetter({
  name: 'borderColor',
  compose: getColor,
  shorthand: true
});
var getBorderStyle = /*#__PURE__*/themeGetter({
  name: 'borderStyle',
  key: 'borderStyles'
});
var border = /*#__PURE__*/style({
  prop: 'border',
  themeGet: getBorder
});
var borderTop = /*#__PURE__*/style({
  prop: 'borderTop',
  themeGet: getBorder
});
var borderRight = /*#__PURE__*/style({
  prop: 'borderRight',
  themeGet: getBorder
});
var borderBottom = /*#__PURE__*/style({
  prop: 'borderBottom',
  themeGet: getBorder
});
var borderLeft = /*#__PURE__*/style({
  prop: 'borderLeft',
  themeGet: getBorder
});
var borderColor = /*#__PURE__*/style({
  prop: 'borderColor',
  themeGet: getBorderColor
});
var borderTopColor = /*#__PURE__*/style({
  prop: 'borderTopColor',
  themeGet: getBorderColor
});
var borderRightColor = /*#__PURE__*/style({
  prop: 'borderRightColor',
  themeGet: getBorderColor
});
var borderBottomColor = /*#__PURE__*/style({
  prop: 'borderBottomColor',
  themeGet: getBorderColor
});
var borderLeftColor = /*#__PURE__*/style({
  prop: 'borderLeftColor',
  themeGet: getBorderColor
});
var borderWidth = /*#__PURE__*/style({
  prop: 'borderWidth',
  themeGet: getBorderWidth
});
var borderTopWidth = /*#__PURE__*/style({
  prop: 'borderTopWidth',
  themeGet: getBorderWidth
});
var borderRightWidth = /*#__PURE__*/style({
  prop: 'borderRightWidth',
  themeGet: getBorderWidth
});
var borderBottomWidth = /*#__PURE__*/style({
  prop: 'borderBottomWidth',
  themeGet: getBorderWidth
});
var borderLeftWidth = /*#__PURE__*/style({
  prop: 'borderLeftWidth',
  themeGet: getBorderWidth
});
var borderStyle = /*#__PURE__*/style({
  prop: 'borderStyle',
  themeGet: getBorderStyle
});
var outline = /*#__PURE__*/style({
  prop: 'outline',
  themeGet: getBorder
});
var outlineColor = /*#__PURE__*/style({
  prop: 'outlineColor',
  themeGet: getColor
});
var outlineWidth = /*#__PURE__*/style({
  prop: 'outlineWidth',
  themeGet: getBorderWidth
});
var outlineStyle = /*#__PURE__*/style({
  prop: 'outlineStyle',
  themeGet: getBorderStyle
});
var getRadius = /*#__PURE__*/themeGetter({
  name: 'radius',
  key: 'radii',
  compose: getPx,
  shorthand: true
});
var borderRadius = /*#__PURE__*/style({
  prop: 'borderRadius',
  themeGet: getRadius
}); // Divide

var divideSelector = "& > :not([hidden]) ~ :not([hidden])";
var divideY = /*#__PURE__*/style({
  prop: 'divideY',
  themeGet: getBorderWidth,
  cssProperty: function cssProperty(value) {
    var _ref;

    var v = value === true ? 1 : value;
    return _ref = {}, _ref[divideSelector] = {
      '--x-divide-y-reverse': 0,
      borderTopWidth: "calc(" + v + " * calc(1 - var(--x-divide-y-reverse)))",
      borderBottomWidth: "calc(" + v + " * var(--x-divide-y-reverse))"
    }, _ref;
  }
});
var divideX = /*#__PURE__*/style({
  prop: 'divideX',
  themeGet: getBorderWidth,
  cssProperty: function cssProperty(value) {
    var _ref2;

    var v = value === true ? 1 : value;
    return _ref2 = {}, _ref2[divideSelector] = {
      '--x-divide-x-reverse': 0,
      borderRightWidth: "calc(" + v + " * var(--x-divide-x-reverse))",
      borderLeftWidth: "calc(" + v + " * calc(1 - var(--x-divide-x-reverse)))"
    }, _ref2;
  }
});
var divideXReverse = /*#__PURE__*/style({
  prop: 'divideXReverse',
  cssProperty: function cssProperty() {
    var _ref3;

    return _ref3 = {}, _ref3[divideSelector] = {
      '--x-divide-x-reverse': '1'
    }, _ref3;
  }
});
var divideYReverse = /*#__PURE__*/style({
  prop: 'divideYReverse',
  cssProperty: function cssProperty() {
    var _ref4;

    return _ref4 = {}, _ref4[divideSelector] = {
      '--x-divide-y-reverse': '1'
    }, _ref4;
  }
});
var divideColor = /*#__PURE__*/style({
  prop: 'divideColor',
  themeGet: getBorderColor,
  cssProperty: function cssProperty(value) {
    var _ref5;

    return _ref5 = {}, _ref5[divideSelector] = {
      borderColor: value
    }, _ref5;
  }
});
var divideStyle = /*#__PURE__*/style({
  prop: 'divideStyle',
  themeGet: getBorderStyle,
  cssProperty: function cssProperty(value) {
    var _ref6;

    return _ref6 = {}, _ref6[divideSelector] = {
      borderStyle: value
    }, _ref6;
  }
});
var getRingWidth = /*#__PURE__*/themeGetter({
  name: 'ringWidth',
  key: 'ringWidths',
  compose: getPx
});
var ring = /*#__PURE__*/style({
  prop: 'ring',
  themeGet: getRingWidth,
  cssProperty: function cssProperty(value) {
    return {
      '--x-ring-shadow': "var(--x-ring-inset, /*!*/ /*!*/) 0 0 0 " + value + " var(--x-ring-color)",
      boxShadow: 'var(--x-ring-shadow, 0 0 #0000), var(--x-shadow, 0 0 #0000)'
    };
  }
});
var ringInset = /*#__PURE__*/style({
  prop: 'ringInset',
  cssProperty: function cssProperty() {
    return {
      '--x-ring-inset': 'inset'
    };
  }
});
var ringColor = /*#__PURE__*/style({
  prop: 'ringColor',
  themeGet: getColor,
  cssProperty: function cssProperty(value) {
    return {
      '--x-ring-color': value
    };
  }
});
var borders = /*#__PURE__*/compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderWidth, borderTopWidth, borderRightWidth, borderBottomWidth, borderLeftWidth, borderStyle, borderRadius, outline, outlineColor, outlineWidth, outlineStyle, divideX, divideY, divideXReverse, divideYReverse, divideColor, divideStyle, ring, ringInset, ringColor);

var getShadow = /*#__PURE__*/themeGetter({
  name: 'shadow',
  key: 'shadows'
});
var opacity = /*#__PURE__*/style({
  prop: 'opacity'
});
var boxShadow = /*#__PURE__*/style({
  prop: 'boxShadow',
  themeGet: getShadow,
  cssProperty: function cssProperty(value) {
    return {
      '--x-shadow': value,
      boxShadow: 'var(--x-ring-shadow, 0 0 #0000), var(--x-shadow)'
    };
  }
});
var textShadow = /*#__PURE__*/style({
  prop: 'textShadow',
  themeGet: getShadow
});
var effects = /*#__PURE__*/compose(opacity, boxShadow, textShadow);

var row = /*#__PURE__*/style({
  prop: 'row',
  cssProperty: function cssProperty() {
    return {
      boxSizing: 'border-box',
      flexGrow: 1,
      flexWrap: 'wrap',
      display: 'flex'
    };
  }
});

function getColStyle(props, size) {
  if (size === true) {
    return {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: '100%'
    };
  }

  if (size === 'auto') {
    return {
      flex: "0 0 auto",
      maxWidth: 'none',
      width: 'auto'
    };
  }

  var sizeWidth = getPercent(size)(props);
  return {
    flex: "0 0 " + sizeWidth,
    maxWidth: sizeWidth
  };
}

var col = /*#__PURE__*/createStyleGenerator(function (props) {
  var value = props.col;
  var common = {
    boxSizing: 'border-box',
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  };

  if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .obj */ .j6)(value)) {
    var breakpointsStyle = reduceBreakpoints(props, value, function (breakpointValue) {
      return getColStyle(props, breakpointValue);
    });
    return _extends({}, common, breakpointsStyle);
  }

  return _extends({}, common, getColStyle(props, value));
}, ['col']);
var flexboxGrids = /*#__PURE__*/compose(row, col);

var display = /*#__PURE__*/style({
  prop: 'display'
});

var _float = /*#__PURE__*/style({
  prop: 'float'
});
var boxSizing = /*#__PURE__*/style({
  prop: 'boxSizing'
});
var container = /*#__PURE__*/createStyleGenerator(function (props) {
  if (!props.container) return null;
  var breakpoints = getBreakpoints(props);
  var styles = reduceBreakpoints(props, breakpoints, function (breakpointValue) {
    return breakpointValue !== 0 ? {
      maxWidth: breakpointValue
    } : {};
  });

  if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .obj */ .j6)(props.container)) {
    styles = reduceBreakpoints(props, props.container, function () {
      return styles;
    });
  }

  return _extends({
    width: '100%'
  }, styles);
}, ['container']);
var overflow = /*#__PURE__*/style({
  prop: 'overflow'
});
var overflowX = /*#__PURE__*/style({
  prop: 'overflowX'
});
var overflowY = /*#__PURE__*/style({
  prop: 'overflowY'
});
var getZIndex = /*#__PURE__*/themeGetter({
  name: 'zIndex',
  key: 'zIndices'
});
var zIndex = /*#__PURE__*/style({
  prop: 'zIndex',
  themeGet: getZIndex
});
var position = /*#__PURE__*/style({
  prop: 'position'
});
var getInset = /*#__PURE__*/themeGetter({
  name: 'inset',
  key: 'inset',
  compose: getPx,
  transform: transformNegative
});
var top = /*#__PURE__*/style({
  prop: 'top',
  themeGet: getInset
});
var right = /*#__PURE__*/style({
  prop: 'right',
  themeGet: getInset
});
var bottom = /*#__PURE__*/style({
  prop: 'bottom',
  themeGet: getInset
});
var left = /*#__PURE__*/style({
  prop: 'left',
  themeGet: getInset
});
var visibility = /*#__PURE__*/style({
  prop: 'visibility'
});
var overscrollBehavior = /*#__PURE__*/style({
  prop: 'overscrollBehavior'
});
var objectFit = /*#__PURE__*/style({
  prop: 'objectFit'
});
var layout = /*#__PURE__*/compose(boxSizing, display, _float, container, overflow, overflowX, overflowY, position, zIndex, top, right, bottom, left, visibility, overscrollBehavior, objectFit);

var alignItems = /*#__PURE__*/style({
  prop: 'alignItems'
});
var alignContent = /*#__PURE__*/style({
  prop: 'alignContent'
});
var justifyContent = /*#__PURE__*/style({
  prop: 'justifyContent'
});
var justifyItems = /*#__PURE__*/style({
  prop: 'justifyItems'
});
var flexWrap = /*#__PURE__*/style({
  prop: 'flexWrap'
});
var flexGrow = /*#__PURE__*/style({
  prop: 'flexGrow'
});
var flexShrink = /*#__PURE__*/style({
  prop: 'flexShrink'
});
var flexBasis = /*#__PURE__*/style({
  prop: 'flexBasis',
  themeGet: getPercent
});
var flexDirection = /*#__PURE__*/style({
  prop: 'flexDirection'
});
var flex = /*#__PURE__*/style({
  prop: 'flex'
});
var justifySelf = /*#__PURE__*/style({
  prop: 'justifySelf'
});
var alignSelf = /*#__PURE__*/style({
  prop: 'alignSelf'
});
var order = /*#__PURE__*/style({
  prop: 'order'
});
var flexboxes = /*#__PURE__*/compose(display, alignItems, alignContent, justifyContent, justifyItems, flexWrap, flexBasis, flexShrink, flexGrow, flexDirection, flex, justifySelf, alignSelf, order);

var getSpace = /*#__PURE__*/themeGetter({
  name: 'space',
  key: 'space',
  compose: getPx,
  transform: transformNegative
});
var margin = /*#__PURE__*/style({
  prop: ['margin', 'm'],
  cssProperty: 'margin',
  themeGet: getSpace
});
var marginTop = /*#__PURE__*/style({
  prop: ['marginTop', 'mt'],
  cssProperty: 'marginTop',
  themeGet: getSpace
});
var marginRight = /*#__PURE__*/style({
  prop: ['marginRight', 'mr'],
  cssProperty: 'marginRight',
  themeGet: getSpace
});
var marginBottom = /*#__PURE__*/style({
  prop: ['marginBottom', 'mb'],
  cssProperty: 'marginBottom',
  themeGet: getSpace
});
var marginLeft = /*#__PURE__*/style({
  prop: ['marginLeft', 'ml'],
  cssProperty: 'marginLeft',
  themeGet: getSpace
});
var mx = /*#__PURE__*/style({
  prop: 'mx',
  cssProperty: ['marginRight', 'marginLeft'],
  themeGet: getSpace
});
var my = /*#__PURE__*/style({
  prop: 'my',
  cssProperty: ['marginTop', 'marginBottom'],
  themeGet: getSpace
});
var padding = /*#__PURE__*/style({
  prop: ['padding', 'p'],
  cssProperty: 'padding',
  themeGet: getSpace
});
var paddingTop = /*#__PURE__*/style({
  prop: ['paddingTop', 'pt'],
  cssProperty: 'paddingTop',
  themeGet: getSpace
});
var paddingRight = /*#__PURE__*/style({
  prop: ['paddingRight', 'pr'],
  cssProperty: 'paddingRight',
  themeGet: getSpace
});
var paddingBottom = /*#__PURE__*/style({
  prop: ['paddingBottom', 'pb'],
  cssProperty: 'paddingBottom',
  themeGet: getSpace
});
var paddingLeft = /*#__PURE__*/style({
  prop: ['paddingLeft', 'pl'],
  cssProperty: 'paddingLeft',
  themeGet: getSpace
});
var px$1 = /*#__PURE__*/style({
  prop: 'px',
  cssProperty: ['paddingRight', 'paddingLeft'],
  themeGet: getSpace
});
var py = /*#__PURE__*/style({
  prop: 'py',
  cssProperty: ['paddingTop', 'paddingBottom'],
  themeGet: getSpace
});
var spaceY = /*#__PURE__*/style({
  prop: 'spaceY',
  themeGet: getSpace,
  cssProperty: function cssProperty(value) {
    return {
      '& > :not([hidden]) ~ :not([hidden])': {
        '--x-space-y-reverse': 0,
        marginTop: "calc(" + value + " * calc(1 - var(--x-space-y-reverse)))",
        marginBottom: "calc(" + value + " * var(--x-space-y-reverse))"
      }
    };
  }
});
var spaceX = /*#__PURE__*/style({
  prop: 'spaceX',
  themeGet: getSpace,
  cssProperty: function cssProperty(value) {
    return {
      '& > :not([hidden]) ~ :not([hidden])': {
        '--x-space-x-reverse': 0,
        marginRight: "calc(" + value + " * var(--x-space-x-reverse))",
        marginLeft: "calc(" + value + " * calc(1 - var(--x-space-x-reverse)))"
      }
    };
  }
});
var spaceXReverse = /*#__PURE__*/style({
  prop: 'spaceXReverse',
  cssProperty: function cssProperty() {
    return {
      '& > :not([hidden]) ~ :not([hidden])': {
        '--x-space-x-reverse': '1'
      }
    };
  }
});
var spaceYReverse = /*#__PURE__*/style({
  prop: 'spaceYReverse',
  cssProperty: function cssProperty() {
    return {
      '& > :not([hidden]) ~ :not([hidden])': {
        '--x-space-y-reverse': '1'
      }
    };
  }
});
var space = /*#__PURE__*/compose(margin, marginTop, marginRight, marginBottom, marginLeft, mx, my, padding, paddingTop, paddingRight, paddingBottom, paddingLeft, px$1, py, spaceX, spaceY, spaceXReverse, spaceYReverse);

var gap = /*#__PURE__*/style({
  prop: 'gap',
  themeGet: getSpace
});
var columnGap = /*#__PURE__*/style({
  prop: 'columnGap',
  themeGet: getSpace
});
var rowGap = /*#__PURE__*/style({
  prop: 'rowGap',
  themeGet: getSpace
});
var gridColumn = /*#__PURE__*/style({
  prop: 'gridColumn'
});
var gridRow = /*#__PURE__*/style({
  prop: 'gridRow'
});
var gridAutoFlow = /*#__PURE__*/style({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = /*#__PURE__*/style({
  prop: 'gridAutoColumns'
});
var gridAutoRows = /*#__PURE__*/style({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = /*#__PURE__*/style({
  prop: 'gridTemplateColumns',
  key: 'gridTemplateColumns'
});
var gridTemplateRows = /*#__PURE__*/style({
  prop: 'gridTemplateRows',
  key: 'gridTemplateRows'
});
var gridTemplateAreas = /*#__PURE__*/style({
  prop: 'gridTemplateAreas'
});
var gridArea = /*#__PURE__*/style({
  prop: 'gridArea'
});
var grids = /*#__PURE__*/compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

var appearance = /*#__PURE__*/style({
  prop: 'appearance'
});
var cursor = /*#__PURE__*/style({
  prop: 'cursor'
});
var pointerEvents = /*#__PURE__*/style({
  prop: 'pointerEvents'
});
var resize = /*#__PURE__*/style({
  prop: 'resize'
});
var userSelect = /*#__PURE__*/style({
  prop: 'userSelect'
});
var interactivity = /*#__PURE__*/compose(appearance, cursor, pointerEvents, resize, userSelect);

var getSize = /*#__PURE__*/themeGetter({
  name: 'size',
  key: 'sizes',
  compose: getPercent
});
var width = /*#__PURE__*/style({
  prop: 'w',
  cssProperty: 'width',
  themeGet: getSize
});
var height = /*#__PURE__*/style({
  prop: 'h',
  cssProperty: 'height',
  themeGet: getSize
});
var maxWidth = /*#__PURE__*/style({
  cssProperty: 'maxWidth',
  prop: ['maxWidth', 'maxW'],
  themeGet: getSize
});
var maxHeight = /*#__PURE__*/style({
  cssProperty: 'maxHeight',
  prop: ['maxHeight', 'maxH'],
  themeGet: getSize
});
var minWidth = /*#__PURE__*/style({
  cssProperty: 'minWidth',
  prop: ['minWidth', 'minW'],
  themeGet: getSize
});
var minHeight = /*#__PURE__*/style({
  cssProperty: 'minHeight',
  prop: ['minHeight', 'minH'],
  themeGet: getSize
});
var sizing = /*#__PURE__*/compose(width, height, maxWidth, maxHeight, minWidth, minHeight);

var fill = /*#__PURE__*/style({
  prop: 'fill',
  themeGet: getColor
});
var stroke = /*#__PURE__*/style({
  prop: 'stroke',
  themeGet: getColor
});
var svg = /*#__PURE__*/compose(fill, stroke);

var borderCollapse = /*#__PURE__*/style({
  prop: 'borderCollapse'
});
var tableLayout = /*#__PURE__*/style({
  prop: 'tableLayout'
});
var tables = /*#__PURE__*/compose(borderCollapse, tableLayout);

var getTransform = /*#__PURE__*/themeGetter({
  name: 'transform',
  key: 'transforms'
});
var transform = /*#__PURE__*/style({
  prop: 'transform',
  themeGet: getTransform,
  cssProperty: function cssProperty(value) {
    if (value === true) {
      return {
        '--x-translate-x': 0,
        '--x-translate-y': 0,
        '--x-rotate': 0,
        '--x-skew-x': 0,
        '--x-skew-y': 0,
        '--x-scale-x': '1',
        '--x-scale-y': '1',
        transform: 'translate3d(var(--x-translate-x), var(--x-translate-y), 0) rotate(var(--x-rotate)) skewX(var(--x-skew-x)) skewY(var(--x-skew-y)) scaleX(var(--x-scale-x)) scaleY(var(--x-scale-y))'
      };
    }

    return {
      transform: value
    };
  }
});
var transformOrigin = /*#__PURE__*/style({
  prop: 'transformOrigin'
});
var translateX = /*#__PURE__*/style({
  prop: 'translateX',
  cssProperty: '--x-translate-x',
  themeGet: getSpace
});
var translateY = /*#__PURE__*/style({
  prop: 'translateY',
  cssProperty: '--x-translate-y',
  themeGet: getSpace
});
var rotate = /*#__PURE__*/style({
  prop: 'rotate',
  cssProperty: '--x-rotate',
  themeGet: getAngle
});
var skewX = /*#__PURE__*/style({
  prop: 'skewX',
  cssProperty: '--x-skew-x',
  themeGet: getAngle
});
var skewY = /*#__PURE__*/style({
  prop: 'skewY',
  cssProperty: '--x-skew-y',
  themeGet: getAngle
});
var scale = /*#__PURE__*/style({
  prop: 'scale',
  cssProperty: ['--x-scale-x', '--x-scale-y'],
  transform: function transform(v) {
    return String(v);
  }
});
var scaleX = /*#__PURE__*/style({
  prop: 'scaleX',
  cssProperty: '--x-scale-x',
  transform: function transform(v) {
    return String(v);
  }
});
var scaleY = /*#__PURE__*/style({
  prop: 'scaleY',
  cssProperty: '--x-scale-y',
  transform: function transform(v) {
    return String(v);
  }
});
var transforms = /*#__PURE__*/compose(transform, transformOrigin, translateX, translateY, rotate, skewX, skewY, scale, scaleX, scaleY);

var getTransition = /*#__PURE__*/themeGetter({
  name: 'transition',
  key: 'transitions'
});
var getTransitionProperty = /*#__PURE__*/themeGetter({
  name: 'transitionProperty',
  key: 'transitionProperties'
});
var getTimingFunction = /*#__PURE__*/themeGetter({
  name: 'timingFunctions',
  key: 'timingFunctions'
});
var transition = /*#__PURE__*/style({
  prop: 'transition',
  themeGet: getTransition
});
var transitionProperty = /*#__PURE__*/style({
  prop: 'transitionProperty',
  themeGet: getTransitionProperty
});
var transitionDuration = /*#__PURE__*/style({
  prop: 'transitionDuration',
  themeGet: getDuration
});
var transitionTimingFunction = /*#__PURE__*/style({
  prop: 'transitionTimingFunction',
  themeGet: getTimingFunction
});
var transitionDelay = /*#__PURE__*/style({
  prop: 'transitionDelay',
  themeGet: getDuration
});
var transitions = /*#__PURE__*/compose(transition, transitionProperty, transitionDuration, transitionTimingFunction, transitionDelay);

var getFont = /*#__PURE__*/themeGetter({
  name: 'font',
  key: 'fonts'
});
var getLineHeight = /*#__PURE__*/themeGetter({
  name: 'lineHeight',
  key: 'lineHeights',
  transform: function transform(value, _ref) {
    var _props$theme$settings, _props$theme, _props$theme$settings2;

    var props = _ref.props;
    var rootFontSize = (_props$theme$settings = props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : (_props$theme$settings2 = _props$theme.settings) == null ? void 0 : _props$theme$settings2.rootFontSize) != null ? _props$theme$settings : undefined;
    return rpx(value, {
      rootFontSize: rootFontSize
    });
  }
});
var getFontWeight = /*#__PURE__*/themeGetter({
  name: 'fontWeight',
  key: 'fontWeights'
});
var getLetterSpacing = /*#__PURE__*/themeGetter({
  name: 'letterSpacing',
  key: 'letterSpacings',
  compose: getPx
});
var getFontSize = /*#__PURE__*/themeGetter({
  name: 'fontSize',
  key: 'fontSizes',
  compose: getPx
});
var fontFamily = /*#__PURE__*/style({
  prop: 'fontFamily',
  themeGet: getFont
});
var fontSize = /*#__PURE__*/style({
  prop: 'fontSize',
  themeGet: getFontSize
});
var lineHeight = /*#__PURE__*/style({
  prop: 'lineHeight',
  themeGet: getLineHeight
});
var fontWeight = /*#__PURE__*/style({
  prop: 'fontWeight',
  themeGet: getFontWeight
});
var fontStyle = /*#__PURE__*/style({
  prop: 'fontStyle'
});
var letterSpacing = /*#__PURE__*/style({
  prop: 'letterSpacing',
  themeGet: getLetterSpacing
});
var color = /*#__PURE__*/style({
  prop: 'color',
  themeGet: getColor
});
var textTransform = /*#__PURE__*/style({
  prop: 'textTransform'
});
var textDecoration = /*#__PURE__*/style({
  prop: 'textDecoration'
});
var textAlign = /*#__PURE__*/style({
  prop: 'textAlign'
});
var verticalAlign = /*#__PURE__*/style({
  prop: 'verticalAlign'
});
var whiteSpace = /*#__PURE__*/style({
  prop: 'whiteSpace'
});
var textOverflow = /*#__PURE__*/style({
  prop: 'textOverflow'
});
var listStyleType = /*#__PURE__*/style({
  prop: 'listStyleType'
});
var listStylePosition = /*#__PURE__*/style({
  prop: 'listStylePosition'
});
var typography = /*#__PURE__*/compose(fontFamily, fontSize, fontStyle, lineHeight, fontWeight, textAlign, letterSpacing, color, textTransform, textDecoration, verticalAlign, whiteSpace, textOverflow, listStyleType, listStylePosition);

var system = /*#__PURE__*/compose(animations, backgrounds, borders, effects, flexboxGrids, flexboxes, grids, interactivity, layout, sizing, space, svg, tables, transforms, transitions, typography);

var th = function th(path, defaultValue) {
  return function (props) {
    var value = (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .getThemeValue */ .u_)(props, path);
    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(value)) return value;
    if ((0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__.is)(defaultValue)) return defaultValue;
    return path;
  };
};
[getAngle, getAnimation, getBorder, getBorderColor, getBorderStyle, getBorderWidth, getColor, getDuration, getFont, getFontSize, getFontWeight, getInset, getLetterSpacing, getLineHeight, getPercent, getPx, getRadius, getRingWidth, getShadow, getSize, getSpace, getTimingFunction, getTransform, getTransition, getTransitionProperty, getZIndex].forEach(function (themeGetter) {
  if (themeGetter.meta.name) {
    th[themeGetter.meta.name] = themeGetter;
  }
});

var up = function up(key, rules) {
  return function (props) {
    var breakpoints = getBreakpoints(props);
    var value = getBreakpointMin(breakpoints, key);
    if (value === null) return rules;
    return [mediaMinWidth(value) + " {", rules, '}'];
  };
};
var down = function down(key, rules) {
  return function (props) {
    var breakpoints = getBreakpoints(props);
    var value = getBreakpointMax(breakpoints, key);
    if (value === null) return null;
    return [mediaMaxWidth(value) + " {", rules, '}'];
  };
};
var between = function between(lower, upper, rules) {
  return function (props) {
    var breakpoints = getBreakpoints(props);
    var min = getBreakpointMin(breakpoints, lower);
    var max = getBreakpointMax(breakpoints, upper);
    if (max === null) return up(lower, rules)(props);
    if (min === null) return down(upper, rules)(props);
    return [mediaBetweenWidth(min, max) + " {", rules, '}'];
  };
};
var breakpoints = function breakpoints(values) {
  return function (props) {
    var allRules = [];
    var keys = Object.keys(values);
    var keysLength = keys.length;

    for (var i = 0; i < keysLength; i++) {
      var key = keys[i];
      var rules = values[key];
      var result = up(key, rules)(props);

      if (Array.isArray(result)) {
        result.forEach(function (v) {
          return allRules.push(v);
        });
      } else {
        allRules.push(result);
      }
    }

    return allRules;
  };
};

var rpxTransformers = {
  px: function px(value) {
    return remPx(rpx(value));
  },
  border: function border(n) {
    return (0,_xstyled_util__WEBPACK_IMPORTED_MODULE_0__/* .num */ .OK)(n) && n > 0 ? remPx(n) + " solid" : n;
  }
};

var defaultAlphaVariants = [0, 5, 10, 20, 25, 30, 40, 50, 60, 70, 75, 80, 90, 95, 100];

function generateAlphaVariants(colors, transform, variants) {
  if (transform === void 0) {
    transform = function transform(x) {
      return x;
    };
  }

  if (variants === void 0) {
    variants = defaultAlphaVariants;
  }

  var alphaColors = Object.keys(colors).reduce(function (obj, key) {
    variants.forEach(function (i) {
      obj[key + "-a" + i] = transform(colors[key], key, i);
    });
    return obj;
  }, _extends({}, colors));
  return alphaColors;
}

function generateHexAlphaVariants(colors, variants) {
  if (variants === void 0) {
    variants = defaultAlphaVariants;
  }

  return generateAlphaVariants(colors, function (value, _, variant) {
    return "" + value + Math.round(variant / 100 * 255).toString(16);
  }, variants);
}
var defaultTones = (/* unused pure expression or super */ null && ([50, 100, 200, 300, 400, 500, 600, 700, 800, 900]));
function aliasColor(alias, color, tones, variants) {
  if (tones === void 0) {
    tones = defaultTones;
  }

  if (variants === void 0) {
    variants = defaultAlphaVariants;
  }

  return tones.reduce(function (obj, tone) {
    obj[alias + "-" + tone] = th.color(color + "-" + tone);
    variants.forEach(function (i) {
      obj[alias + "-" + tone + "-a" + i] = th.color(color + "-" + tone + "-a" + i);
    });
    return obj;
  }, {});
}

var space$1 = {
  0.5: '0.125rem',
  1: '0.25rem',
  1.5: '0.375rem',
  2: '0.5rem',
  2.5: '0.625rem',
  3: '0.75rem',
  3.5: '0.875rem',
  4: '1rem',
  5: '1.25rem',
  6: '1.5rem',
  7: '1.75rem',
  8: '2rem',
  9: '2.25rem',
  10: '2.5rem',
  11: '2.75rem',
  12: '3rem',
  14: '3.5rem',
  16: '4rem',
  20: '5rem',
  24: '6rem',
  28: '7rem',
  32: '8rem',
  36: '9rem',
  40: '10rem',
  44: '11rem',
  48: '12rem',
  52: '13rem',
  56: '14rem',
  60: '15rem',
  64: '16rem',
  72: '18rem',
  80: '20rem',
  96: '24rem'
};
var timingFunctions = {
  'ease-in': 'cubic-bezier(0.4, 0, 1, 1)',
  'ease-out': 'cubic-bezier(0, 0, 0.2, 1)',
  'ease-in-out': 'cubic-bezier(0.4, 0, 0.2, 1)'
};
var transitionProperties = {
  "default": ['background-color', 'border-color', 'color', 'fill', 'stroke', 'opacity', 'box-shadow', 'transform'],
  colors: ['background-color', 'border-color', 'color', 'fill', 'stroke'],
  opacity: ['opacity'],
  shadow: ['box-shadow'],
  transform: ['transform']
};
var transitions$1 = /*#__PURE__*/Object.keys(transitionProperties).reduce(function (obj, key) {
  obj[key] = transitionProperties[key].map(function (property) {
    return property + " " + timingFunctions['ease-in-out'] + " 150ms";
  }).join(',');
  return obj;
}, {});
var colors = {
  black: '#000000',
  white: '#ffffff',
  'blue-gray-50': '#f8fafc',
  'blue-gray-100': '#f1f5f9',
  'blue-gray-200': '#e2e8f0',
  'blue-gray-300': '#cbd5e1',
  'blue-gray-400': '#94a3b8',
  'blue-gray-500': '#64748b',
  'blue-gray-600': '#475569',
  'blue-gray-700': '#334155',
  'blue-gray-800': '#1e293b',
  'blue-gray-900': '#0f172a',
  'cool-gray-50': '#f9fafb',
  'cool-gray-100': '#f3f4f6',
  'cool-gray-200': '#e5e7eb',
  'cool-gray-300': '#d1d5db',
  'cool-gray-400': '#9ca3af',
  'cool-gray-500': '#6b7280',
  'cool-gray-600': '#4b5563',
  'cool-gray-700': '#374151',
  'cool-gray-800': '#1f2937',
  'cool-gray-900': '#111827',
  'gray-50': '#fafafa',
  'gray-100': '#f4f4f5',
  'gray-200': '#e4e4e7',
  'gray-300': '#d4d4d8',
  'gray-400': '#a1a1aa',
  'gray-500': '#71717a',
  'gray-600': '#52525b',
  'gray-700': '#3f3f46',
  'gray-800': '#27272a',
  'gray-900': '#18181b',
  'true-gray-50': '#fafafa',
  'true-gray-100': '#f5f5f5',
  'true-gray-200': '#e5e5e5',
  'true-gray-300': '#d4d4d4',
  'true-gray-400': '#a3a3a3',
  'true-gray-500': '#737373',
  'true-gray-600': '#525252',
  'true-gray-700': '#404040',
  'true-gray-800': '#262626',
  'true-gray-900': '#171717',
  'warm-gray-50': '#fafaf9',
  'warm-gray-100': '#f5f5f4',
  'warm-gray-200': '#e7e5e4',
  'warm-gray-300': '#d6d3d1',
  'warm-gray-400': '#a8a29e',
  'warm-gray-500': '#78716c',
  'warm-gray-600': '#57534e',
  'warm-gray-700': '#44403c',
  'warm-gray-800': '#292524',
  'warm-gray-900': '#1c1917',
  'red-50': '#fef2f2',
  'red-100': '#fee2e2',
  'red-200': '#fecaca',
  'red-300': '#fca5a5',
  'red-400': '#f87171',
  'red-500': '#ef4444',
  'red-600': '#dc2626',
  'red-700': '#b91c1c',
  'red-800': '#991b1b',
  'red-900': '#7f1d1d',
  'orange-50': '#fff7ed',
  'orange-100': '#ffedd5',
  'orange-200': '#fed7aa',
  'orange-300': '#fdba74',
  'orange-400': '#fb923c',
  'orange-500': '#f97316',
  'orange-600': '#ea580c',
  'orange-700': '#c2410c',
  'orange-800': '#9a3412',
  'orange-900': '#7c2d12',
  'amber-50': '#fffbeb',
  'amber-100': '#fef3c7',
  'amber-200': '#fde68a',
  'amber-300': '#fcd34d',
  'amber-400': '#fbbf24',
  'amber-500': '#f59e0b',
  'amber-600': '#d97706',
  'amber-700': '#b45309',
  'amber-800': '#92400e',
  'amber-900': '#78350f',
  'yellow-50': '#fefce8',
  'yellow-100': '#fef9c3',
  'yellow-200': '#fef08a',
  'yellow-300': '#fde047',
  'yellow-400': '#facc15',
  'yellow-500': '#eab308',
  'yellow-600': '#ca8a04',
  'yellow-700': '#a16207',
  'yellow-800': '#854d0e',
  'yellow-900': '#713f12',
  'lime-50': '#f7fee7',
  'lime-100': '#ecfccb',
  'lime-200': '#d9f99d',
  'lime-300': '#bef264',
  'lime-400': '#a3e635',
  'lime-500': '#84cc16',
  'lime-600': '#65a30d',
  'lime-700': '#4d7c0f',
  'lime-800': '#3f6212',
  'lime-900': '#365314',
  'green-50': '#f0fdf4',
  'green-100': '#dcfce7',
  'green-200': '#bbf7d0',
  'green-300': '#86efac',
  'green-400': '#4ade80',
  'green-500': '#22c55e',
  'green-600': '#16a34a',
  'green-700': '#15803d',
  'green-800': '#166534',
  'green-900': '#14532d',
  'emerald-50': '#ecfdf5',
  'emerald-100': '#d1fae5',
  'emerald-200': '#a7f3d0',
  'emerald-300': '#6ee7b7',
  'emerald-400': '#34d399',
  'emerald-500': '#10b981',
  'emerald-600': '#059669',
  'emerald-700': '#047857',
  'emerald-800': '#065f46',
  'emerald-900': '#064e3b',
  'teal-50': '#f0fdfa',
  'teal-100': '#ccfbf1',
  'teal-200': '#99f6e4',
  'teal-300': '#5eead4',
  'teal-400': '#2dd4bf',
  'teal-500': '#14b8a6',
  'teal-600': '#0d9488',
  'teal-700': '#0f766e',
  'teal-800': '#115e59',
  'teal-900': '#134e4a',
  'cyan-50': '#ecfeff',
  'cyan-100': '#cffafe',
  'cyan-200': '#a5f3fc',
  'cyan-300': '#67e8f9',
  'cyan-400': '#22d3ee',
  'cyan-500': '#06b6d4',
  'cyan-600': '#0891b2',
  'cyan-700': '#0e7490',
  'cyan-800': '#155e75',
  'cyan-900': '#164e63',
  'light-blue-50': '#f0f9ff',
  'light-blue-100': '#e0f2fe',
  'light-blue-200': '#bae6fd',
  'light-blue-300': '#7dd3fc',
  'light-blue-400': '#38bdf8',
  'light-blue-500': '#0ea5e9',
  'light-blue-600': '#0284c7',
  'light-blue-700': '#0369a1',
  'light-blue-800': '#075985',
  'light-blue-900': '#0c4a6e',
  'blue-50': '#eff6ff',
  'blue-100': '#dbeafe',
  'blue-200': '#bfdbfe',
  'blue-300': '#93c5fd',
  'blue-400': '#60a5fa',
  'blue-500': '#3b82f6',
  'blue-600': '#2563eb',
  'blue-700': '#1d4ed8',
  'blue-800': '#1e40af',
  'blue-900': '#1e3a8a',
  'indigo-50': '#eef2ff',
  'indigo-100': '#e0e7ff',
  'indigo-200': '#c7d2fe',
  'indigo-300': '#a5b4fc',
  'indigo-400': '#818cf8',
  'indigo-500': '#6366f1',
  'indigo-600': '#4f46e5',
  'indigo-700': '#4338ca',
  'indigo-800': '#3730a3',
  'indigo-900': '#312e81',
  'violet-50': '#f5f3ff',
  'violet-100': '#ede9fe',
  'violet-200': '#ddd6fe',
  'violet-300': '#c4b5fd',
  'violet-400': '#a78bfa',
  'violet-500': '#8b5cf6',
  'violet-600': '#7c3aed',
  'violet-700': '#6d28d9',
  'violet-800': '#5b21b6',
  'violet-900': '#4c1d95',
  'purple-50': '#faf5ff',
  'purple-100': '#f3e8ff',
  'purple-200': '#e9d5ff',
  'purple-300': '#d8b4fe',
  'purple-400': '#c084fc',
  'purple-500': '#a855f7',
  'purple-600': '#9333ea',
  'purple-700': '#7e22ce',
  'purple-800': '#6b21a8',
  'purple-900': '#581c87',
  'fuchsia-50': '#fdf4ff',
  'fuchsia-100': '#fae8ff',
  'fuchsia-200': '#f5d0fe',
  'fuchsia-300': '#f0abfc',
  'fuchsia-400': '#e879f9',
  'fuchsia-500': '#d946ef',
  'fuchsia-600': '#c026d3',
  'fuchsia-700': '#a21caf',
  'fuchsia-800': '#86198f',
  'fuchsia-900': '#701a75',
  'pink-50': '#fdf2f8',
  'pink-100': '#fce7f3',
  'pink-200': '#fbcfe8',
  'pink-300': '#f9a8d4',
  'pink-400': '#f472b6',
  'pink-500': '#ec4899',
  'pink-600': '#db2777',
  'pink-700': '#be185d',
  'pink-800': '#9d174d',
  'pink-900': '#831843',
  'rose-50': '#fff1f2',
  'rose-100': '#ffe4e6',
  'rose-200': '#fecdd3',
  'rose-300': '#fda4af',
  'rose-400': '#fb7185',
  'rose-500': '#f43f5e',
  'rose-600': '#e11d48',
  'rose-700': '#be123c',
  'rose-800': '#9f1239',
  'rose-900': '#881337'
};
var defaultTheme = {
  colors: /*#__PURE__*/generateHexAlphaVariants(colors),
  space: space$1,
  screens: {
    _: 0,
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536
  },
  durations: {
    instant: '100ms',
    'fast-in': '250ms',
    'fast-out': '200ms',
    'slow-in': '300ms',
    'slow-out': '250ms'
  },
  sizes: /*#__PURE__*/_extends({}, space$1, {
    0.5: undefined,
    1: undefined,
    '0.5s': space$1[0.5],
    '1s': space$1[1],
    full: '100%',
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    '7xl': '80rem'
  }),
  radii: {
    none: '0',
    sm: '0.125rem',
    "default": '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    full: '9999px'
  },
  shadows: {
    xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    "default": '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    outline: '0 0 0 3px rgba(66, 153, 225, 0.5)'
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    "default": '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
    '7xl': '4.5rem',
    '8xl': '6rem',
    '9xl': '8rem'
  },
  fontWeights: {
    hairline: '100',
    thin: '200',
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900'
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    serif: "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    sans: "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\""
  },
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0em',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em'
  },
  lineHeights: {
    none: 1,
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
    3: '.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem'
  },
  gridTemplateColumns: {
    1: 'repeat(1, minmax(0, 1fr))',
    2: 'repeat(2, minmax(0, 1fr))',
    3: 'repeat(3, minmax(0, 1fr))',
    4: 'repeat(4, minmax(0, 1fr))',
    5: 'repeat(5, minmax(0, 1fr))',
    6: 'repeat(6, minmax(0, 1fr))',
    7: 'repeat(7, minmax(0, 1fr))',
    8: 'repeat(8, minmax(0, 1fr))',
    9: 'repeat(9, minmax(0, 1fr))',
    10: 'repeat(10, minmax(0, 1fr))',
    11: 'repeat(11, minmax(0, 1fr))',
    12: 'repeat(12, minmax(0, 1fr))'
  },
  gridTemplateRows: {
    1: 'repeat(1, minmax(0, 1fr))',
    2: 'repeat(2, minmax(0, 1fr))',
    3: 'repeat(3, minmax(0, 1fr))',
    4: 'repeat(4, minmax(0, 1fr))',
    5: 'repeat(5, minmax(0, 1fr))',
    6: 'repeat(6, minmax(0, 1fr))'
  },
  borderWidths: {
    "default": 1
  },
  ringWidths: {
    "default": 3
  },
  borders: {
    "default": '1px solid transparent'
  },
  transitions: transitions$1,
  transitionProperties: transitionProperties,
  timingFunctions: timingFunctions,
  animations: {
    spin: 'x-spin 1s linear infinite',
    ping: 'x-ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
    pulse: 'x-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    bounce: 'x-bounce 1s infinite'
  }
};

var _templateObject;
var createPreflight = function createPreflight(_ref) {
  var createGlobalStyle = _ref.createGlobalStyle;
  return createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    /*! modern-normalize v1.0.0 | MIT License | https://github.com/sindresorhus/modern-normalize */\n    *,::after,::before{box-sizing:border-box}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}body{font-family:system-ui,-apple-system,'Segoe UI',Roboto,Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji'}hr{height:0;color:inherit}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:ui-monospace,SFMono-Regular,Consolas,'Liberation Mono',Menlo,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}::-moz-focus-inner{border-style:none;padding:0}:-moz-focusring{outline:1px dotted ButtonText}:-moz-ui-invalid{box-shadow:none}legend{padding:0}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}\n\n    /* Role button pointer */\n    [role=button], button {\n      cursor: pointer;\n    }\n\n    /* Remove default margins */\n    blockquote,\n    dl,\n    dd,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    hr,\n    figure,\n    p,\n    pre {\n      margin: 0;\n    }\n\n    /* Remove headings styles */\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-size: inherit;\n      font-weight: inherit;\n    }\n\n    /* Unstyle lists */\n    ol,\n    ul {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n    }\n\n    /* Image are block-level */\n    img,\n    svg,\n    video,\n    canvas,\n    audio,\n    iframe,\n    embed,\n    object {\n      display: block;\n      vertical-align: middle;\n    }\n\n    /* Reset border styles */\n    *,\n    ::before,\n    ::after {\n      border-width: 0;\n      border-style: solid;\n      border-color: ", ";\n    }\n\n    * {\n      --x-ring-color: ", ";\n    }\n\n    /* Default outline on buttons */\n    button:focus {\n      outline: 1px dotted;\n      outline: 5px auto -webkit-focus-ring-color;\n    }\n\n    // Animations\n    @keyframes x-spin {\n      from {\n        transform: rotate(0deg);\n      }\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes x-ping {\n      0% {\n        transform: scale(1);\n        opacity: 1;\n      }\n      75%, 100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes x-pulse {\n      0%, 100% {\n        opacity: 1;\n      }\n      50% {\n        opacity: .5;\n      }\n    }\n\n    @keyframes x-bounce {\n      0%, 100% {\n        transform: translateY(-25%);\n        animationTimingFunction: cubic-bezier(0.8, 0, 1, 1);\n      }\n      50% {\n        transform: translateY(0);\n        animationTimingFunction: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n  "])), th.color('default-border-color', 'currentColor'), th.color('default-ring-color', 'rgba(59,130,246,0.5)'));
};


//# sourceMappingURL=system.esm.js.map


/***/ }),

/***/ 4583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gg": function() { return /* binding */ cascade; },
/* harmony export */   "J": function() { return /* binding */ flattenStrings; },
/* harmony export */   "OK": function() { return /* binding */ num; },
/* harmony export */   "TS": function() { return /* binding */ merge; },
/* harmony export */   "Yl": function() { return /* binding */ func; },
/* harmony export */   "ZK": function() { return /* binding */ warn; },
/* harmony export */   "Z_": function() { return /* binding */ string; },
/* harmony export */   "f0": function() { return /* binding */ assign; },
/* harmony export */   "is": function() { return /* binding */ is; },
/* harmony export */   "j6": function() { return /* binding */ obj; },
/* harmony export */   "pd": function() { return /* binding */ negative; },
/* harmony export */   "u_": function() { return /* binding */ getThemeValue; },
/* harmony export */   "yR": function() { return /* binding */ identity; }
/* harmony export */ });
/* unused harmony exports flatten, get, omit */
/* eslint-disable no-console */
var DEV = "production" !== 'production';
/**
 * Identity function.
 * @param x
 */

var identity = function identity(x) {
  return x;
};
/**
 * Check if a value is not null and not undefined.
 * @param n
 */

var is = function is(n) {
  return n !== undefined && n !== null;
};
/**
 * Check if a value is a number.
 * @param n
 */

var num = function num(n) {
  return typeof n === 'number' && !Number.isNaN(n);
};
/**
 * Check if a value is a string.
 * @param n
 */

var string = function string(n) {
  return typeof n === 'string' && n !== '';
};
/**
 * Check if a value is an object.
 * @param n
 */

var obj = function obj(n) {
  return typeof n === 'object' && n !== null;
};
/**
 * Check if a value is a function.
 * @param n
 */

var func = function func(n) {
  return typeof n === 'function';
};
/**
 * Check if a value is a negative number.
 * @param n
 */

var negative = function negative(n) {
  return num(n) && n < 0;
};
/**
 * Get a value from an object or an array.
 * @param from
 * @param path
 */

var get = function get(from, path) {
  var paths = String(path).split('.');
  var pathsLength = paths.length;
  var result = from;

  for (var i = 0; i < pathsLength; i += 1) {
    if (result === undefined) return result;
    var _path = paths[i];
    result = is(result[_path]) ? result[_path] : undefined;
  }

  return result;
};
/**
 * Assign object into another
 * @param a
 * @param b
 */

var assign = function assign(a, b) {
  // @ts-ignore
  if (!is(b)) return a; // eslint-disable-next-line no-restricted-syntax, guard-for-in

  for (var key in b) {
    // @ts-ignore
    a[key] = b[key];
  } // @ts-ignore


  return a;
};
/**
 * Merge deeply one object into another.
 * @param a
 * @param b
 */

var merge = function merge(a, b) {
  // @ts-ignore
  if (!is(b)) return a; // eslint-disable-next-line no-restricted-syntax

  for (var key in b) {
    // eslint-disable-next-line no-continue
    // @ts-ignore
    if (obj(a[key])) {
      // @ts-ignore
      a[key] = merge(assign({}, a[key]), b[key]);
    } else {
      // @ts-ignore
      a[key] = b[key];
    }
  } // @ts-ignore


  return a;
};
/**
 * Warn if a condition is not met.
 * @param condition
 * @param message
 */

var warn = function warn(condition, message) {
  if (DEV) {
    if (!condition && console.error) {
      console.error(message);
    }
  }
};
/**
 * Recursively call a function until getting something that is not a function.
 * @param value
 * @param arg
 */

function cascade(value, arg) {
  if (typeof value === 'function') {
    return cascade(value(arg), arg);
  }

  return value;
}
/**
 * Get value from theme.
 * @param props
 * @param path
 * @param initial
 */

var getThemeValue = function getThemeValue(props, path, initial) {
  if (initial === void 0) {
    initial = props.theme;
  }

  return cascade(get(initial, path), props);
};
/**
 * Omit values from an object.
 * @param object
 * @param values
 */

function omit(object, values) {
  var result = {}; // eslint-disable-next-line no-restricted-syntax

  for (var key in object) {
    if (values.indexOf(key) === -1) {
      result[key] = object[key];
    }
  }

  return result;
}
/* eslint-disable no-continue, no-loop-func, no-cond-assign */

/**
 * Flatten every string together in an array.
 * @param array
 */

function flattenStrings(array) {
  return array.reduce(function (flattenedArray, value) {
    var lastIndex = flattenedArray.length - 1;
    var last = flattenedArray[lastIndex];

    if (typeof last === 'string' && typeof value === 'string') {
      flattenedArray[lastIndex] = last + value;
    } else {
      flattenedArray.push(value);
    }

    return flattenedArray;
  }, []);
}

function flattenDown(array, result) {
  for (var i = 0; i < array.length; i++) {
    var value = array[i];

    if (Array.isArray(value)) {
      flattenDown(value, result);
    } else {
      result.push(value);
    }
  }

  return result;
}
/**
 * Flatten an array.
 * @param array
 */


function flatten(array) {
  return flattenDown(array, []);
}


//# sourceMappingURL=util.esm.js.map


/***/ })

}]);